// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:59:22.568Z
// Property: Bremerton Park Apartment Homes (ID: 6767906449167589)
// Collections: 21 amenities, 5 floorplans (live), 37 photos, 79 POIs, 3 reviews, 5 virtual tours, 5 office hours, 18 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167589",
  "property_external_id": "1124079",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/bremerton-park-apartment-homes-prairie-village-ks/7bjq46x/",
  "property_google_business_url": "https://www.google.com/maps/place/Bremerton+Park+Apartment+Homes/@38.992128,-94.659752,889m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0ec116f06bcc9:0xe4e20b3a05bad702!8m2!3d38.992128!4d-94.659752!16s%2Fg%2F1tcxq5sc?entry=ttu&g_ep=EgoyMDI2MDgxMi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124079 p1099031",
  "property_status": null,
  "property_slug": "bremerton-park-apartment-homes",
  "property_name": "Bremerton Park Apartment Homes",
  "property_website_url": "https://www.bremertonparkapts.com/",
  "property_domain": "https://www.bremertonparkapts.com/",
  "property_address": "6313 W 75th St",
  "property_full_address": "6313 W 75th St, Prairie Village, KS 66204",
  "property_address_1": "6313 W 75th St",
  "property_address_2": null,
  "property_address_city": "Prairie Village",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66204",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Outlying Johnson County KS",
  "property_address_latitude": "38.9922804",
  "property_address_longitude": "-94.6595662",
  "property_email": "rentcafe.bp@pricekc.com",
  "property_phone": "(913) 728-5736",
  "property_call_tracking_phone": "913-728-5736",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Space, greenery, and everyday ease in Prairie Village.</strong> Bremerton Park pairs roomy one- and two-bedroom homes with modern kitchens, large closets, landscaped courtyards, and practical conveniences—inviting you to explore the layouts and features that fit your day.</p>",
  "property_long_description": "Come home to Bremerton Park Apartments in Prairie Village, Kansas. Relax and enjoy our rural living just steps away from bustling Kansas City. Located just on the outskirts of Kansas City, we are nestled in a park-like atmosphere but within a short driving distance to shopping, restaurants and entertainment. We pride ourselves on being a friendly community so let us help you find your new home at Bremerton Park. Let us welcome you to your new home!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-900f-7558-9b04-70b8dad0f4c5.webp",
  "property_featured_image_media": {
    "alt_text": "Kitchen with breakfast bar and two stools",
    "public_id": "01a0101b-900f-7558-9b04-70b8dad0f4c5",
    "storage_key": "property/6767906449167589/01a0101b-900f-7558-9b04-70b8dad0f4c5.webp",
    "width": 1200,
    "height": 800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "136",
  "property_year_built": "1977",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.38235294117648",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-275",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restricted Breeds: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://bremertonparkapts.securecafeapplicant.com/onlineleasing/content3/access/bremerton-park/floorplans",
  "property_resident_portal_url": "https://bremertonparkapts.securecafe.com/residentservices/bremerton-park/userlogin.aspx",
  "property_apply_now_url": "https://bremertonparkapts.securecafeapplicant.com/onlineleasing/content3/access/bremerton-park/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc922-fd19-75db-9137-0c88d15d6f8e.webp",
  "property_primary_logo_media": {
    "alt_text": "Bremerton Park logo",
    "public_id": "019fc922-fd19-75db-9137-0c88d15d6f8e",
    "storage_key": "property/6767906449167589/019fc922-fd19-75db-9137-0c88d15d6f8e.webp",
    "width": 353,
    "height": 150
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc923-c556-77ae-8e8a-5145e50b6bb7.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fc923-c556-77ae-8e8a-5145e50b6bb7",
    "storage_key": "property/6767906449167589/019fc923-c556-77ae-8e8a-5145e50b6bb7.webp",
    "width": 353,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc923-ba5d-735f-bc78-b4cb97e1f7b9.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc923-ba5d-735f-bc78-b4cb97e1f7b9",
    "storage_key": "property/6767906449167589/019fc923-ba5d-735f-bc78-b4cb97e1f7b9.webp",
    "width": 353,
    "height": 150
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#7CA6C1",
  "property_secondary_color": "#002D72",
  "property_font_color": null,
  "property_color_4": "#4A6954",
  "property_color_3": "#976640",
  "property_color_5": "#C56E29",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "800 - 1100",
  "property_sqft_min": "800",
  "property_sqft_max": "1100",
  "property_price_range": "1102 - 4124",
  "property_price_min": "1102",
  "property_price_max": "4124",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/BremertonPark/",
  "property_instagram_url": "https://www.instagram.com/bremertonparkapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJybwGbxHswIcRAte6BToL4uQ",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Bremerton Park Apartment Homes",
  "property_home_romance_title": "Embrace Your New Beginning in Our Charming Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Everyday comfort, simplified.</strong> Bremerton Park Apartment Homes brings ease to daily life with controlled gated access, reserved resident parking, package service, online payments, and on-site maintenance. Unwind outdoors with landscaped courtyards, picnic areas, grills, and a refreshing pool, then come home to a spacious Prairie Village apartment with large closets, a defined dining area, dishwasher, and a balcony or patio. Select homes add vaulted ceilings or washer/dryer hookups.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans that keep life easy.</strong> Choose from one- and two-bedroom apartment homes in Prairie Village with everyday essentials that make each layout feel polished and practical—large closets, defined dining space, eat-in kitchens with dishwasher and disposal, plus a balcony or patio for fresh air. Select homes add vaulted ceilings or washer/dryer hookups, while every floor plan includes air conditioning, window coverings, and easy-care finishes.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Bremerton Park.</strong> Preview bright living rooms, clean-lined kitchens, defined dining areas, and balconies made for an easy outdoor pause. The full gallery also captures mature courtyard landscaping, wooden walkways, stone-accented exteriors, and sunny pool-and-pavilion moments that bring the Prairie Village setting into focus.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Everyday Prairie Village convenience, with Kansas City close.</strong> From Bremerton Park, 75th Street keeps coffee, meals, errands, and services within easy reach at Trail West Shopping Center, 75th Street Shops, and Met 75 Shops. RideKC service runs along the corridor, while Antioch Park, Loose Park, the Nelson-Atkins area, Midtown, Overland Park, and Mission are all easy to access when the day calls for more.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents call Bremerton Park a hidden gem.</strong> Reviews point to beautifully maintained grounds, a relaxing pool, quiet surroundings, and spacious layouts that make everyday living feel easy. Praise also goes to the responsive, helpful team and the community’s convenient Prairie Village location. Read the reviews to see what stands out most.</p>",
  "property_neighborhood_blurb": "<p><strong>Map out a Prairie Village routine with options in every direction.</strong> From Bremerton Park, 75th Street puts quick errands, casual meals, coffee stops, and services close by at Trail West Shopping Center, 75th Street Shops, and Met 75 Shops, while RideKC’s 75th Street route adds a transit connection across the corridor. When you want more room to roam, Antioch Park is a short drive west, with Loose Park, the Nelson-Atkins area, and Midtown Kansas City easy to reach east of State Line. You’re also positioned near the Overland Park and Mission edges, giving the neighborhood a practical mix of leafy residential streets, everyday convenience, and city access. Start with the map below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location fits your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Comfort shows up in the everyday details.</strong> At Bremerton Park Apartment Homes, amenities are designed to make daily routines feel simple—from controlled gated access and reserved resident parking to package service, online payments, and on-site maintenance.</p><p>Outside, landscaped courtyards, picnic areas, grills, and the pool create easy places to unwind without leaving the community. Inside your Prairie Village apartment, enjoy roomy layouts with large closets, a defined dining area, dishwasher, disposal, window coverings, and a balcony or patio; select homes add vaulted ceilings or washer/dryer hookups. Browse the <a href=\"/gallery\">photo gallery</a> to picture the spaces, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Bremerton Park home?</strong> Start your online application for a roomy one- or two-bedroom apartment with modern kitchen finishes, large closets, and everyday conveniences in a relaxed Prairie Village setting with landscaped courtyards and simple resident app access.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Reach out to the Bremerton Park Apartment Homes leasing team for help with roomy one- and two-bedroom layouts, current details, or finding your way to our Prairie Village community along 75th Street. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Bremerton Park?</strong> Start here for quick answers about our Prairie Village apartment homes, leasing details, amenities, and everyday conveniences. If you don’t see what you need, the leasing team is happy to help you find the right next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your everyday rhythm.</strong> Bremerton Park Apartment Homes makes choosing simple with one-bedroom Astoria, Louisville, and Lexington designs and two-bedroom Belmont and Saratoga homes—each giving you room to spread out without overcomplicating the search. As you compare floor plans in Prairie Village, look for practical details that make a difference from day one: large closets, defined dining space, an eat-in kitchen with a dishwasher and disposal, and a balcony or patio that adds a little breathing room.</p><p>Select layouts add vaulted ceilings or washer/dryer hookups, while every option keeps comfort front and center with air conditioning, window coverings, and easy-care finishes. Browse current availability, then use the photos and <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see your favorite floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>See Bremerton Park from the angles that matter.</strong> Browse photos that move from bright, open living rooms to clean-lined kitchens, defined dining areas, and balconies that add an easy outdoor pause to your day. The gallery highlights the community’s quieter visual details, too: mature courtyard landscaping, wooden walkways, stone-accented exteriors, and apartment entries with a more tucked-away feel.</p><p>Outside, picture sunny afternoons by the <a href=\"/amenities\">pool and pavilion</a>, a shaded picnic table under the covered deck, or a stroll through green courtyard paths in Prairie Village. Inside, look for the space, storage, and everyday finishes that make each layout easy to imagine as your own. When a photo catches your eye, compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the details in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Bremerton Park from the map.</strong> Browse available apartments, see where courtyards and everyday conveniences fit in, and get a feel for the connected Prairie Village location near 75th Street, Lamar Avenue, shopping, parks, dining, and Kansas City destinations.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with room to roam.</strong> At Bremerton Park Apartment Homes, dogs and cats can settle into a routine that feels easy from day one. Step out through your private outside entrance, take a quiet loop through scenic courtyards with mature landscaping, or enjoy a fresh-air break on your balcony or patio after a walk.</p><p>You’ll also have access to the Pet Royalty Club, adding a little extra value with pet-focused perks and local offers. With everyday conveniences, green community spaces, and helpful pet care options nearby in Prairie Village, Bremerton Park makes it simpler to care for your four-legged roommate. Review the policy details below, then explore more <a href=\"/amenities\">community amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_referafriend_blurb": "<p><strong>Share the ease of Bremerton Park.</strong> If you love the roomy layouts, modern kitchens, landscaped courtyards, and connected Prairie Village setting, invite a friend to take a look. Send a referral and help them find their next apartment home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made simple.</strong> Log in to handle everyday details at Bremerton Park Apartment Homes, from online rent payments through the resident app to maintenance requests and account updates—so home life stays as easy as the roomy layouts, landscaped courtyards, and practical conveniences around you.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying.</strong> Reviews for Bremerton Park Apartment Homes highlight the details that make daily living feel easy: beautifully kept grounds, a relaxing pool, quiet surroundings, and a team known for being kind, helpful, and quick to respond. Residents often call out the value, spacious layouts, and convenient Prairie Village setting, with one reviewer describing the community as “a true hidden gem.”</p><p>As you browse the ratings, you’ll find praise for attentive service, well-maintained apartments, and the green spaces that give the property its comfortable feel. Ready to experience it for yourself? Explore the <a href=\"/amenities\">community features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_created_at": "1785785860681",
  "property_scheduletour_blurb": "<p><strong>See the space, greenery, and everyday ease up close.</strong> Tour Bremerton Park Apartment Homes to explore roomy layouts, modern kitchens, large closets, private outside entrances, and landscaped courtyards with a pool and pavilion. Schedule your visit today and picture your next move in Prairie Village.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will follow up soon. In the meantime, picture everyday ease at Bremerton Park, with roomy one- and two-bedroom layouts, relaxed landscaped courtyards, and a connected Prairie Village location. You can also explore our <a href=\"/floor-plans\">floor plans</a> before we connect.</p>",
  "property_virtualtours_blurb": "<p><strong>Start with the walkthrough, not the guesswork.</strong> Explore Bremerton Park Apartment Homes from wherever you are with virtual tours of the Astoria, Louisville, Lexington, Belmont, and Saratoga apartment layouts. Move room by room through one- and two-bedroom options, compare how each floor plan opens from living area to kitchen and dining space, and notice details that matter on screen: bright rooms, generous closets, window coverings, and the ease of a balcony or patio in select views.</p><p>Use the tours to narrow your favorites before you visit Prairie Village in person. After you’ve stepped through the spaces online, compare current <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the details up close.</p>",
  "property_copyright": "2026 All Rights Reserved. Bremerton Park Apartment Homes",
  "property_seo_title_home": "Bremerton Park Apartment Homes |  Apartments in Prairie Village, KS",
  "property_seo_description_home": "Discover modern living at Bremerton Park, Prairie Village, KS—spacious floor plans, resort-style amenities, and a vibrant community await!",
  "property_seo_title_floorplans": "Floor Plans | Prairie Village, KS Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Bremerton Park Apartments in Prairie Village, KS. Choose from stylish one or two-bedroom floor plans to call home!",
  "property_seo_title_amenities": "Amenities | Prairie Village, KS Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort and style at Bremerton Park in Prairie Village, KS! Enjoy modern layouts, a stunning pool, and welcoming courtyards.",
  "property_seo_title_gallery": "Gallery | Apartments in Prairie Village, KS",
  "property_seo_description_gallery": "Discover Bremerton Park in Prairie Village, KS: spacious floor plans, inviting amenities, and scenic courtyards. Envision your perfect home!",
  "property_seo_title_virtualtours": "Virtual Tours | Bremerton Park Apartment Homes Apartments",
  "property_seo_description_virtualtours": "Step inside Bremerton Park Apartment Homes in Prairie Village, KS! Take a virtual tour of our stylish one and two-bedroom floor plans today!",
  "property_seo_title_interactivemap": "Interactive Map | Bremerton Park Apartment Homes Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Bremerton Park, Prairie Village, KS. Enjoy spacious layouts and top-notch amenities—tailor your living experience today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Prairie Village, KS",
  "property_seo_description_neighborhood": "Uncover the charm of Prairie Village at Bremerton Park! Dive into local favorites and vibrant neighborhoods just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Bremerton Park Apartment Homes",
  "property_seo_description_contact": "Discover cozy living at Bremerton Park in Prairie Village, KS. Explore our one and two-bedroom layouts. Contact our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Prairie Village, KS",
  "property_seo_description_faqs": "Elevate your lifestyle at Bremerton Park in Prairie Village, KS! Our FAQs reveal answers about spacious floor plans, amenities, and community living.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Prairie Village, KS",
  "property_seo_description_reviews": "Join the vibrant life at Bremerton Park in Prairie Village, KS! Check out our resident reviews and see why our community feels like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Prairie Village, KS",
  "property_seo_description_applynow": "Discover modern living at Bremerton Park, Prairie Village, KS. Enjoy spacious layouts, premium amenities, and a pet-friendly community. Lease online!",
  "property_seo_title_residentaccess": "Resident Access | Bremerton Park Apartment Homes",
  "property_seo_description_residentaccess": "Access your Bremerton Park resident portal for easy rent payments, maintenance requests, and community updates—making your Prairie Village living seamless!",
  "property_seo_title_referafriend": "Refer A Friend | Bremerton Park Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to Bremerton Park Apartment Homes in Prairie Village! Great friends make the best neighbors—join our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Bremerton Park Apartment Homes",
  "property_seo_description_scheduletour": "Experience the charm of Bremerton Park Apartment Homes in Prairie Village, KS. Schedule a tour today and find your perfect home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Bremerton Park Apartment Homes",
  "property_seo_description_privacy": "At Bremerton Park Apartments in Prairie Village, KS, your privacy matters. Review our policy to see how we protect your information.",
  "property_seo_title_accessibility": "Website Accessibility | Bremerton Park Apartment Homes",
  "property_seo_description_accessibility": "Experience comfort at Bremerton Park in Prairie Village, KS. We're committed to digital inclusion, ensuring everyone feels at home online. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Bremerton Park Apartment Homes",
  "property_seo_description_sitemap": "Explore Bremerton Park Apartments in Prairie Village, KS. Discover amenities, floor plans, and community info—check it out now!",
  "property_seo_title_thankyou": "Thank You | Bremerton Park Apartment Homes",
  "property_seo_description_thankyou": "Thanks for reaching out! A team member from Bremerton Park Apartment Homes will contact you shortly to assist with your apartment search.",
  "property_seo_title_pets": "Pet Policy | Apartments in Prairie Village, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793628970940",
  "amenities": [
    {
      "id": "ec_94377c87b579eb89e568b147",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037390",
      "title": "Shimmering Swimming Pool with a Pavilion",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-9bcb-77d4-81be-d5f677c39124.webp",
      "amenity_image_media": {
        "alt_text": "Covered picnic area with picnic tables and a view of the pool and apartment buildings.",
        "public_id": "01a0101b-9bcb-77d4-81be-d5f677c39124",
        "storage_key": "property/6767906449167589/01a0101b-9bcb-77d4-81be-d5f677c39124.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Covered Wooden deck at Bremerton Park Apartment Homes , Prairie Village, KS,Covered Wooden deck with picnic tables at Bremerton Park Apartment Homes , Prairie Village, KS, 66204,Swimming Pool surrounded by the Lounge chairs at Bremerton Park Apartment Homes , Prairie Village, 66204,Sunset view of Pool at Bremerton Park Apartment Homes , Prairie Village,Breathtaking view of the pool at Bremerton Park Apartment Homes , Prairie Village, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21bf0a720926c4b831ec7228",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037368",
      "title": "On-site Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c98eb50f2974c9077be728f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037375",
      "title": "Scenic Courtyards with Mature Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-9c99-727c-bbba-341ccd35cfc6.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment buildings with a walking path and bridge.",
        "public_id": "01a0101b-9c99-727c-bbba-341ccd35cfc6",
        "storage_key": "property/6767906449167589/01a0101b-9c99-727c-bbba-341ccd35cfc6.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Wooden walkways through the yard at Bremerton Park Apartment Homes , Prairie Village, Kansas,Wooden bridge with external view of property at Bremerton Park Apartment Homes , Prairie Village, Kansas,Wooden bridge with Greenery around at Bremerton Park Apartment Homes , Prairie Village, 66204",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_696f63cfef1f125dd557d1af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037385",
      "title": "Professional Management with 24 Hour Emergency Maintenance Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df0278cbe288a502053e2b7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037367",
      "title": "Reserved Resident Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5257c4c8ed1fa0b330ea712",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037388",
      "title": "Guest Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f1fae905368a59692b442ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037374",
      "title": "Private Outside Entrances",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-9aac-70bc-b23d-a9908bbd1885.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and a pool area in the background.",
        "public_id": "01a0101b-9aac-70bc-b23d-a9908bbd1885",
        "storage_key": "property/6767906449167589/01a0101b-9aac-70bc-b23d-a9908bbd1885.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "Modern apartment complex view at Bremerton Park Apartment Homes , Prairie Village, Kansas,Apartment Exterior at Bremerton Park Apartment Homes , Prairie Village, 66204,modern apartment building with a stone facade and balconies at Bremerton Park Apartment Homes , Prairie Village",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65427ffadc9746708899e854",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "120962200",
      "title": "Pet Royalty Club",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-9f50-7149-a48c-f3b8448f2334.webp",
      "amenity_image_media": {
        "alt_text": "Person walking a dog on a leash on a sidewalk.",
        "public_id": "01a0101b-9f50-7149-a48c-f3b8448f2334",
        "storage_key": "property/6767906449167589/01a0101b-9f50-7149-a48c-f3b8448f2334.webp",
        "width": 3072,
        "height": 2050
      },
      "amenity_image_alt_text": "Cute Puppy at Bremerton Park Apartment Homes , Kansas, 66204",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b7f4e5b31e412423316473c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "120958333",
      "title": "Online Rental Payments & Resident App",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d506b23d5537bde753b49eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "122755345",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45cdca01f8a711b91ff0a548",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037365",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-9b13-753e-9652-711b1a586ec8.webp",
      "amenity_image_media": {
        "alt_text": "Modern living room with a fireplace, city skyline artwork, and a white armchair.",
        "public_id": "01a0101b-9b13-753e-9652-711b1a586ec8",
        "storage_key": "property/6767906449167589/01a0101b-9b13-753e-9652-711b1a586ec8.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Warm And Inviting Living Room at Bremerton Park Apartments Homes in Prairie Village, Kansas,Trendy Living Room at Bremerton Park Apartment Homes , Kansas, 66204",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c4d8525a481d43826aa10ebb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037361",
      "title": "Private Balconies and Patios",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-aa59-75f2-ba49-e8710cc033c9.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with seating area and large sliding glass doors overlooking greenery.",
        "public_id": "01a0101b-aa59-75f2-ba49-e8710cc033c9",
        "storage_key": "property/6767906449167589/01a0101b-aa59-75f2-ba49-e8710cc033c9.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Private patio with a table and chair at Bremerton Park Apartment Homes , Kansas, 66204,Private balcony with chair and table at Bremerton Park Apartment Homes , Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e369d9b4aa2bcee9acfaf8c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037363",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-b2d5-71ec-8a55-45acb9abfc04.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with white walls, a dresser with artwork, and a closet.",
        "public_id": "01a0101b-b2d5-71ec-8a55-45acb9abfc04",
        "storage_key": "property/6767906449167589/01a0101b-b2d5-71ec-8a55-45acb9abfc04.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Bedroom with a large and comfortable bed  and closet at Bremerton Park Apartment Homes , Prairie Village, KS, 66204",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d15c561af38655ae25abddf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037355",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-ad1d-7119-b35b-0e4d7097f59a.webp",
      "amenity_image_media": {
        "alt_text": "Bright kitchen with white cabinets, oven, sink, dishwasher, and refrigerator.",
        "public_id": "01a0101b-ad1d-7119-b35b-0e4d7097f59a",
        "storage_key": "property/6767906449167589/01a0101b-ad1d-7119-b35b-0e4d7097f59a.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Modern kitchen with a refrigerator at Bremerton Park Apartments Homes in Prairie Village, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99be99e13ad705f37c58126e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "120962234",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f1e4ae838bddf4cd13af76e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "120962231",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_713de0a6f925864670966219",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037353",
      "title": "Mini Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c16b312e5e13752ad51883cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "120962232",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc34c6e38abfcd523d160c7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037360",
      "title": "Extra Large Modern Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-ae3b-728f-96f1-aea69fb24775.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a kitchen island and bar stools.",
        "public_id": "01a0101b-ae3b-728f-96f1-aea69fb24775",
        "storage_key": "property/6767906449167589/01a0101b-ae3b-728f-96f1-aea69fb24775.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Beautifully decorated ,Well Lit Living Room at Bremerton Park Apartment Homes , Prairie Village, KS, 66204",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af7ba19a8ac1484f80d8ea07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037347",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-c2e4-727c-b20b-51e54974da0e.webp",
      "amenity_image_media": {
        "alt_text": "White kitchen with white cabinets, oven, refrigerator, and dining area.",
        "public_id": "01a0101b-c2e4-727c-b20b-51e54974da0e",
        "storage_key": "property/6767906449167589/01a0101b-c2e4-727c-b20b-51e54974da0e.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "Well Equipped Eat-In Kitchen at Bremerton Park Apartment Homes , Prairie Village, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_55ac551bd02ec4a9f313f4e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "external_id": "88037356",
      "title": "Vertical Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-ca54-725f-974a-d6276e0db1ae.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a dresser and a closet.",
        "public_id": "01a0101b-ca54-725f-974a-d6276e0db1ae",
        "storage_key": "property/6767906449167589/01a0101b-ca54-725f-974a-d6276e0db1ae.webp",
        "width": 1600,
        "height": 1200
      },
      "amenity_image_alt_text": "Bedroom with a large comfortable bed and closet and attached patio at Bremerton Park Apartment Homes , Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_0695b88a72171168f81af45e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-900f-7558-9b04-70b8dad0f4c5.webp",
      "image_media": {
        "alt_text": "Kitchen with breakfast bar and two stools",
        "public_id": "01a0101b-900f-7558-9b04-70b8dad0f4c5",
        "storage_key": "property/6767906449167589/01a0101b-900f-7558-9b04-70b8dad0f4c5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern kitchen area featuring a breakfast bar with two stools, ample cabinet space, and a stove. The exposed wooden beams add a rustic touch to the space.",
      "link": "false",
      "alt_text": "Kitchen with breakfast bar and two stools",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-6313 W 75th St -5.jpg"
    },
    {
      "id": "ec_684e5b1f51ca5f99228c36c1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-d8cb-76ca-a17b-0bdf45b07dc0.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with breakfast bar in a rental apartment.",
        "public_id": "01a0101b-d8cb-76ca-a17b-0bdf45b07dc0",
        "storage_key": "property/6767906449167589/01a0101b-d8cb-76ca-a17b-0bdf45b07dc0.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Bright and airy living room featuring a breakfast bar with bar stools, leading into a spacious living area with comfortable seating and modern decor.",
      "link": "false",
      "alt_text": "Living room and kitchen area with breakfast bar in a rental apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-6313 W 75th St -4(1).jpg"
    },
    {
      "id": "ec_badaa4c5a742241b3da81ff6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-d939-722b-b87d-29ebbfb52e31.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with white cabinets, a grey countertop, and a large mirror.",
        "public_id": "01a0101b-d939-722b-b87d-29ebbfb52e31",
        "storage_key": "property/6767906449167589/01a0101b-d939-722b-b87d-29ebbfb52e31.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with ample counter space, storage cabinets, and a bathtub with a patterned shower curtain.",
      "link": "false",
      "alt_text": "Bathroom vanity with white cabinets, a grey countertop, and a large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-6313 W 75th St -17(1).jpg"
    },
    {
      "id": "ec_39b0f1115c41322f1adcc4ac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-d93a-7759-afe6-3e116d76c2c1.webp",
      "image_media": {
        "alt_text": "Bedroom with a sliding glass door to a patio and a closet.",
        "public_id": "01a0101b-d93a-7759-afe6-3e116d76c2c1",
        "storage_key": "property/6767906449167589/01a0101b-d93a-7759-afe6-3e116d76c2c1.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a sliding glass door that opens to a private patio and a convenient walk-in closet.",
      "link": "false",
      "alt_text": "Bedroom with a sliding glass door to a patio and a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-6313 W 75th St -16(1).jpg"
    },
    {
      "id": "ec_5f89e800c73d829828e9302f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-d797-741b-8bb3-2b1e0ac2bf35.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, appliances, and wood flooring.",
        "public_id": "01a0101b-d797-741b-8bb3-2b1e0ac2bf35",
        "storage_key": "property/6767906449167589/01a0101b-d797-741b-8bb3-2b1e0ac2bf35.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen featuring ample cabinet space, a full suite of appliances, and warm wood flooring, creating a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, appliances, and wood flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-6313 W 75th St -12(1).jpg"
    },
    {
      "id": "ec_250b8f22e7e4f42089bca307",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-d92e-7721-8aae-21efcea51fe2.webp",
      "image_media": {
        "alt_text": "Living room with vaulted ceilings, exposed beam, and modern furniture.",
        "public_id": "01a0101b-d92e-7721-8aae-21efcea51fe2",
        "storage_key": "property/6767906449167589/01a0101b-d92e-7721-8aae-21efcea51fe2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room with vaulted ceilings, exposed beam, and stylish modern furniture, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living room with vaulted ceilings, exposed beam, and modern furniture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-6313 W 75th St -8.jpg"
    },
    {
      "id": "ec_78abcfb06207dacb63a658ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-e6d9-72a9-8ddb-9ebd4ae44dfb.webp",
      "image_media": {
        "alt_text": "Modern living room with open kitchen and dining area, featuring high ceilings and city skyline artwork.",
        "public_id": "01a0101b-e6d9-72a9-8ddb-9ebd4ae44dfb",
        "storage_key": "property/6767906449167589/01a0101b-e6d9-72a9-8ddb-9ebd4ae44dfb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living area with a modern aesthetic, seamlessly connecting to an open kitchen and dining space. High ceilings and tasteful decor create an inviting atmosphere.",
      "link": "false",
      "alt_text": "Modern living room with open kitchen and dining area, featuring high ceilings and city skyline artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-6313 W 75th St -6.jpg"
    },
    {
      "id": "ec_aec8513564e5790c6bb4e1cc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-e63d-7630-906b-c87f191dc83a.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel sink, and range, with a dining area visible beyond.",
        "public_id": "01a0101b-e63d-7630-906b-c87f191dc83a",
        "storage_key": "property/6767906449167589/01a0101b-e63d-7630-906b-c87f191dc83a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright and airy kitchen featuring white cabinetry, a double sink, and a full-size range, opening to a dining area with comfortable seating.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, stainless steel sink, and range, with a dining area visible beyond.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-6313 W 75th St -13(1).jpg"
    },
    {
      "id": "ec_a876c7ebb9f5629d7421116b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-e7a8-7618-a74b-184210a501a8.webp",
      "image_media": {
        "alt_text": "Modern living room with vaulted ceilings, a plush armchair, and a view into the kitchen.",
        "public_id": "01a0101b-e7a8-7618-a74b-184210a501a8",
        "storage_key": "property/6767906449167589/01a0101b-e7a8-7618-a74b-184210a501a8.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed living space featuring vaulted ceilings, a cozy armchair, and a sleek kitchen perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern living room with vaulted ceilings, a plush armchair, and a view into the kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-6313 W 75th St -7.jpg"
    },
    {
      "id": "ec_09fd3df0530b0329210a230b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-e800-76f2-bc40-60b4b64ec460.webp",
      "image_media": {
        "alt_text": "A modern bedroom with a large bed, bedside tables, and a dresser.",
        "public_id": "01a0101b-e800-76f2-bc40-60b4b64ec460",
        "storage_key": "property/6767906449167589/01a0101b-e800-76f2-bc40-60b4b64ec460.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this well-appointed bedroom. Featuring a plush king-size bed, elegant decor, and ample natural light, it's the perfect retreat.",
      "link": "false",
      "alt_text": "A modern bedroom with a large bed, bedside tables, and a dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-6313 W 75th St -14(1).jpg"
    },
    {
      "id": "ec_edb4897aa3af2102323efa5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-e98e-70d1-a19b-1f9218427024.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-size bed, nightstands, and a closet.",
        "public_id": "01a0101b-e98e-70d1-a19b-1f9218427024",
        "storage_key": "property/6767906449167589/01a0101b-e98e-70d1-a19b-1f9218427024.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into comfort in this inviting bedroom, featuring a plush king-size bed, elegant nightstands, and ample closet space for all your storage needs.",
      "link": "false",
      "alt_text": "Spacious bedroom with a king-size bed, nightstands, and a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-6313 W 75th St -23.jpg"
    },
    {
      "id": "ec_a72d7d5b6fd13ef00fc878e2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-f25d-74de-b531-da625b088f01.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, TV, and a large window.",
        "public_id": "01a0101b-f25d-74de-b531-da625b088f01",
        "storage_key": "property/6767906449167589/01a0101b-f25d-74de-b531-da625b088f01.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, complete with a comfortable bed, a modern entertainment center with a flat-screen TV, and a large window offering scenic views.",
      "link": "false",
      "alt_text": "Bedroom with a bed, TV, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-6313 W 75th St -11(1).jpg"
    },
    {
      "id": "ec_89a2d220e6615da64a176122",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-f351-73f9-9229-c6421a0aeaff.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a TV and a walk-in closet.",
        "public_id": "01a0101b-f351-73f9-9229-c6421a0aeaff",
        "storage_key": "property/6767906449167589/01a0101b-f351-73f9-9229-c6421a0aeaff.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a mounted television, a sleek media console, and a convenient walk-in closet with organized shelving.",
      "link": "false",
      "alt_text": "Modern bedroom with a TV and a walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-6313 W 75th St -10.jpg"
    },
    {
      "id": "ec_ee5d949ae4e1c31ceb6a00ff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-f436-7719-b034-095ebb0001b4.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-sized bed, white linens, and a dark green throw blanket.",
        "public_id": "01a0101b-f436-7719-b034-095ebb0001b4",
        "storage_key": "property/6767906449167589/01a0101b-f436-7719-b034-095ebb0001b4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-sized bed and elegant decor.",
      "link": "false",
      "alt_text": "Cozy bedroom with a queen-sized bed, white linens, and a dark green throw blanket.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/21-6313 W 75th St -24.jpg"
    },
    {
      "id": "ec_f1eebffe4447035966747cf8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-f5b7-733b-a000-90c9c3d4510a.webp",
      "image_media": {
        "alt_text": "A bright bedroom with a king-sized bed, white vertical blinds, and two framed botanical prints.",
        "public_id": "01a0101b-f5b7-733b-a000-90c9c3d4510a",
        "storage_key": "property/6767906449167589/01a0101b-f5b7-733b-a000-90c9c3d4510a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this spacious bedroom, featuring a plush king-sized bed, ample natural light, and tasteful decor. Enjoy direct access to outdoor spaces through the sliding glass doors.",
      "link": "false",
      "alt_text": "A bright bedroom with a king-sized bed, white vertical blinds, and two framed botanical prints.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-6313 W 75th St -15.jpg"
    },
    {
      "id": "ec_00e51a7a21f372c2f6df0aec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-f814-75ba-adb6-887329269a33.webp",
      "image_media": {
        "alt_text": "Balcony with seating and sliding glass doors.",
        "public_id": "01a0101b-f814-75ba-adb6-887329269a33",
        "storage_key": "property/6767906449167589/01a0101b-f814-75ba-adb6-887329269a33.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony or patio, perfect for outdoor relaxation and entertaining.",
      "link": "false",
      "alt_text": "Balcony with seating and sliding glass doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-6313 W 75th St -18.jpg"
    },
    {
      "id": "ec_d19dbdba6c70069ce55a17fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-fe36-76bd-a1b6-853c566fa791.webp",
      "image_media": {
        "alt_text": "Balcony with table, chairs, champagne, and view into a bedroom.",
        "public_id": "01a0101b-fe36-76bd-a1b6-853c566fa791",
        "storage_key": "property/6767906449167589/01a0101b-fe36-76bd-a1b6-853c566fa791.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony. This tranquil space offers a perfect spot to unwind, with a glimpse into the comfortable bedroom.",
      "link": "false",
      "alt_text": "Balcony with table, chairs, champagne, and view into a bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-6313 W 75th St -21.jpg"
    },
    {
      "id": "ec_b455907a63a4e8fb71600855",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-ff25-77ca-8856-72fb906a9a37.webp",
      "image_media": {
        "alt_text": "Balcony view with table, champagne, and parked cars below",
        "public_id": "01a0101b-ff25-77ca-8856-72fb906a9a37",
        "storage_key": "property/6767906449167589/01a0101b-ff25-77ca-8856-72fb906a9a37.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening drinks on this private balcony, offering a relaxing view of the neighborhood and convenient parking.",
      "link": "false",
      "alt_text": "Balcony view with table, champagne, and parked cars below",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-6313 W 75th St -22.jpg"
    },
    {
      "id": "ec_5d514c9242dd7161eafcb430",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-023c-72f9-a65f-f5f0255c14b9.webp",
      "image_media": {
        "alt_text": "Balcony with outdoor seating overlooking a pool and apartment buildings.",
        "public_id": "01a0101c-023c-72f9-a65f-f5f0255c14b9",
        "storage_key": "property/6767906449167589/01a0101c-023c-72f9-a65f-f5f0255c14b9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy your morning coffee on the private balcony, with views of the resort-style pool and lush green landscaping.",
      "link": "false",
      "alt_text": "Balcony with outdoor seating overlooking a pool and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-6313 W 75th St -20(1).jpg"
    },
    {
      "id": "ec_1cc90f09b34ab259bc8ccf90",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-042c-7154-960a-db369bdd0c07.webp",
      "image_media": {
        "alt_text": "View from balcony overlooking a courtyard with a swimming pool and apartment buildings.",
        "public_id": "01a0101c-042c-7154-960a-db369bdd0c07",
        "storage_key": "property/6767906449167589/01a0101c-042c-7154-960a-db369bdd0c07.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Enjoy the serene courtyard views from your private balcony, complete with a refreshing swimming pool and lush greenery.",
      "link": "false",
      "alt_text": "View from balcony overlooking a courtyard with a swimming pool and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-6313 W 75th St -19(1).jpg"
    },
    {
      "id": "ec_3bd0dd27aea4a047c92cb50e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-11c1-757d-aba1-e553c28502bc.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and covered pavilion at dusk with apartment buildings in the background.",
        "public_id": "01a0101c-11c1-757d-aba1-e553c28502bc",
        "storage_key": "property/6767906449167589/01a0101c-11c1-757d-aba1-e553c28502bc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our beautiful outdoor pool or relax under the covered pavilion. The perfect place to unwind and enjoy the evening at our community.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and covered pavilion at dusk with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-dsc09104 virtual twilight(1).jpg"
    },
    {
      "id": "ec_152c39c52a5759d083763cae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-099d-7538-b6c0-08ba499225d9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a0101c-099d-7538-b6c0-08ba499225d9",
        "storage_key": "property/6767906449167589/01a0101c-099d-7538-b6c0-08ba499225d9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-DSC09044(2).jpg"
    },
    {
      "id": "ec_94aa03d69e59e4448254d286",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-0c09-75b2-a649-5989cd9cfe8f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered cabana area.",
        "public_id": "01a0101c-0c09-75b2-a649-5989cd9cfe8f",
        "storage_key": "property/6767906449167589/01a0101c-0c09-75b2-a649-5989cd9cfe8f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, complete with comfortable lounge chairs and a shaded cabana for ultimate relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered cabana area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-DSC09069(2).jpg"
    },
    {
      "id": "ec_5de365d44eea70db48dfcc5b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-0f2e-715e-996d-4574fe2f44b8.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a0101c-0f2e-715e-996d-4574fe2f44b8",
        "storage_key": "property/6767906449167589/01a0101c-0f2e-715e-996d-4574fe2f44b8.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and the beautiful apartment buildings.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-DSC09009(3).jpg"
    },
    {
      "id": "ec_b4c542593283cea2b9eab77b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-9bcb-77d4-81be-d5f677c39124.webp",
      "image_media": {
        "alt_text": "Covered picnic area with picnic tables and a view of the pool and apartment buildings.",
        "public_id": "01a0101b-9bcb-77d4-81be-d5f677c39124",
        "storage_key": "property/6767906449167589/01a0101b-9bcb-77d4-81be-d5f677c39124.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings in our covered picnic area, complete with picnic tables and a scenic view of the pool and surrounding apartment buildings.",
      "link": "false",
      "alt_text": "Covered picnic area with picnic tables and a view of the pool and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-DSC09115(1).jpg"
    },
    {
      "id": "ec_05d45d06c5577e00ecd10d93",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-19a6-775e-809d-173e89056c3e.webp",
      "image_media": {
        "alt_text": "Covered picnic area next to the swimming pool.",
        "public_id": "01a0101c-19a6-775e-809d-173e89056c3e",
        "storage_key": "property/6767906449167589/01a0101c-19a6-775e-809d-173e89056c3e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation in our covered picnic area, conveniently located beside the sparkling swimming pool.",
      "link": "false",
      "alt_text": "Covered picnic area next to the swimming pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-dsc09125 virtual twilight(1).jpg"
    },
    {
      "id": "ec_21162c09d32419e744b4f912",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-4f45-7131-b0da-49924b6b10ab.webp",
      "image_media": {
        "alt_text": "Wooden bridge over a grassy area with apartment buildings in the background.",
        "public_id": "01a0101c-4f45-7131-b0da-49924b6b10ab",
        "storage_key": "property/6767906449167589/01a0101c-4f45-7131-b0da-49924b6b10ab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming wooden bridge leading through a lush green courtyard with apartment buildings visible in the distance.",
      "link": "false",
      "alt_text": "Wooden bridge over a grassy area with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/44-6313 W 75th St-23(2).jpg"
    },
    {
      "id": "ec_ee8d3c3b6973f20094c6c142",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-3a78-743a-b08f-0df37d663433.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a wooden bridge over a path and a swimming pool.",
        "public_id": "01a0101c-3a78-743a-b08f-0df37d663433",
        "storage_key": "property/6767906449167589/01a0101c-3a78-743a-b08f-0df37d663433.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment buildings with a scenic wooden bridge and a sparkling swimming pool, set amidst lush green landscaping.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with a wooden bridge over a path and a swimming pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/43-6313 W 75th St-22(1).jpg"
    },
    {
      "id": "ec_476410a67c817fbda43c0612",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-9c99-727c-bbba-341ccd35cfc6.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a walking path and bridge.",
        "public_id": "01a0101b-9c99-727c-bbba-341ccd35cfc6",
        "storage_key": "property/6767906449167589/01a0101b-9c99-727c-bbba-341ccd35cfc6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds with a charming walking path and bridge leading to the apartment buildings.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with a walking path and bridge.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-DSC09289(1).jpg"
    },
    {
      "id": "ec_a544881ee45377ecc26a65d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-1fcf-7543-85f4-f5216a3eae44.webp",
      "image_media": {
        "alt_text": "Bremerton Park Apartments monument sign with 1 & 2 bedroom apartments listed.",
        "public_id": "01a0101c-1fcf-7543-85f4-f5216a3eae44",
        "storage_key": "property/6767906449167589/01a0101c-1fcf-7543-85f4-f5216a3eae44.webp",
        "width": 963,
        "height": 642
      },
      "title": "Community",
      "description": "Welcome to Bremerton Park Apartments, offering 1 & 2 bedroom apartment homes. Discover comfortable living in a vibrant community.",
      "link": "false",
      "alt_text": "Bremerton Park Apartments monument sign with 1 & 2 bedroom apartments listed.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/4BP-Amenities-7.jpg"
    },
    {
      "id": "ec_65ea02ee7c629f80eba1814f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101b-9aac-70bc-b23d-a9908bbd1885.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and a pool area in the background.",
        "public_id": "01a0101b-9aac-70bc-b23d-a9908bbd1885",
        "storage_key": "property/6767906449167589/01a0101b-9aac-70bc-b23d-a9908bbd1885.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings, showcasing balconies, outdoor spaces, and community amenities like a pool.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and a pool area in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-DJI_20250916105226_0878_D(1).jpg"
    },
    {
      "id": "ec_3aad87dc7ec97065cba09ecb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-2d97-706b-9af9-cbc932ce43ec.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with stone accents and balconies.",
        "public_id": "01a0101c-2d97-706b-9af9-cbc932ce43ec",
        "storage_key": "property/6767906449167589/01a0101c-2d97-706b-9af9-cbc932ce43ec.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Discover comfortable living in these apartment buildings, featuring charming stone accents and private balconies. Enjoy the beautifully landscaped grounds and convenient walkways.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with stone accents and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-DSC09324(1).jpg"
    },
    {
      "id": "ec_8d43387b76bacbd14d000cef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-2ff2-74d6-9518-0a52d876071b.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and surrounding green space.",
        "public_id": "01a0101c-2ff2-74d6-9518-0a52d876071b",
        "storage_key": "property/6767906449167589/01a0101c-2ff2-74d6-9518-0a52d876071b.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Exterior view showcasing the apartment buildings, their balconies, and the well-maintained landscaping.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and surrounding green space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-DJI_20250916104829_0848_D(1).jpg"
    },
    {
      "id": "ec_859d5f0bc292c40acc287a97",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-3756-74ea-993d-f7acc0bc2d80.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a swimming pool and walking paths.",
        "public_id": "01a0101c-3756-74ea-993d-f7acc0bc2d80",
        "storage_key": "property/6767906449167589/01a0101c-3756-74ea-993d-f7acc0bc2d80.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy the community amenities, including a swimming pool and well-maintained grounds with walking paths.",
      "link": "false",
      "alt_text": "Apartment buildings with a swimming pool and walking paths.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-DSC09379(1).jpg"
    },
    {
      "id": "ec_bae4ff6d95d6c14ba62ac712",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-3a49-75cc-8316-a18757928859.webp",
      "image_media": {
        "alt_text": "Outdoor pavilion with picnic tables and grills in a grassy area with apartment buildings in the background.",
        "public_id": "01a0101c-3a49-75cc-8316-a18757928859",
        "storage_key": "property/6767906449167589/01a0101c-3a49-75cc-8316-a18757928859.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at our community pavilion, complete with grills and picnic tables. A perfect spot for residents to relax and socialize.",
      "link": "false",
      "alt_text": "Outdoor pavilion with picnic tables and grills in a grassy area with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-DSC09174(1).jpg"
    },
    {
      "id": "ec_5fe0519bf2f2505701bd9003",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-3d37-7452-b0b1-18dce531a649.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies, walkways, and green space.",
        "public_id": "01a0101c-3d37-7452-b0b1-18dce531a649",
        "storage_key": "property/6767906449167589/01a0101c-3d37-7452-b0b1-18dce531a649.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Discover comfortable living in these apartment buildings featuring private balconies and convenient access to community amenities.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies, walkways, and green space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-DSC09189(1).jpg"
    },
    {
      "id": "ec_4ef1d7b0a14051d19572c527",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-47a9-72b0-aa78-a2d50c91ac35.webp",
      "image_media": {
        "alt_text": "Exterior stairs and hallway with leasing office sign.",
        "public_id": "01a0101c-47a9-72b0-aa78-a2d50c91ac35",
        "storage_key": "property/6767906449167589/01a0101c-47a9-72b0-aa78-a2d50c91ac35.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Exterior stairs and hallway with leasing office sign. Access to units and amenities.",
      "link": "false",
      "alt_text": "Exterior stairs and hallway with leasing office sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-DSC09245(1).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_b7c1eb5e-bbf3-43ed-8ed8-3c9a25237788",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Tavern in the Village",
      "poi_type": "Restaurants",
      "poi_address": "3901 Prairie Ln, Prairie Village, KS 66208, USA",
      "poi_short_description": "Modern American cuisine, wine & cocktails served in an urbane neighborhood hangout.",
      "poi_long_description": "Modern American cuisine, wine & cocktails served in an urbane neighborhood hangout.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-a49c-70b2-922a-1b230b363ed5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-a49c-70b2-922a-1b230b363ed5",
        "storage_key": "property/6767906449167589/019fc924-a49c-70b2-922a-1b230b363ed5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://taverninthevillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15589883409027637969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tavern-in-the-village",
      "poi_latitude": "39.0034003",
      "poi_longitude": "-94.630695",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-529-2229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV70WnZbuwIcR0SLZnFxkWtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_5ca03918-a388-4430-82d1-cdd0dc78c3f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "French Market",
      "poi_type": "Restaurants",
      "poi_address": "6943 Tomahawk Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "Cozy cafe, deli and market featuring pastries and familiar French mainstays.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-7a4f-738a-af4c-a25b5e447832.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-7a4f-738a-af4c-a25b5e447832",
        "storage_key": "property/6767906449167589/019fc924-7a4f-738a-af4c-a25b5e447832.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.frenchmarketkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4840073241545006794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "french-market",
      "poi_latitude": "39.00281409999999",
      "poi_longitude": "-94.6317092",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-362-0803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdxYXo5buwIcRyt4pKfhkK0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "french_restaurant"
    },
    {
      "id": "custom_212ef3b5-8cf7-4f6c-a7e2-95ba33152716",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Café Provence",
      "poi_type": "Restaurants",
      "poi_address": "3936 W 69th Terrace, Prairie Village, KS 66208, USA",
      "poi_short_description": "Celebrated country-chic bistro presenting a seasonal French menu & wines in a suburban setting.",
      "poi_long_description": "Celebrated country-chic bistro presenting a seasonal French menu & wines in a suburban setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-7843-701b-aff5-2100d967087b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-7843-701b-aff5-2100d967087b",
        "storage_key": "property/6767906449167589/019fc924-7843-701b-aff5-2100d967087b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://cafeprovencekc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5019603118366936895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caf-provence",
      "poi_latitude": "39.0025311",
      "poi_longitude": "-94.6314752",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-384-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCVjvUZbuwIcRP0-073A2qUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "french_restaurant"
    },
    {
      "id": "custom_3e3a0dde-035f-485f-a266-853694ccbbff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Scratch Gourmet Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "3931 W 69th Terrace, Prairie Village, KS 66208, USA",
      "poi_short_description": "Eatery featuring reimagined favorites, wine pairings and takeout options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-7946-768f-9a7e-21898da70009.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-7946-768f-9a7e-21898da70009",
        "storage_key": "property/6767906449167589/019fc924-7946-768f-9a7e-21898da70009.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.scratchgourmet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4995658132339136312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scratch-gourmet-kitchen",
      "poi_latitude": "39.0020451",
      "poi_longitude": "-94.6312542",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-218-0178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIezdFwnvwIcROJddbZokVEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_90b4fe31-f097-4b15-a3e6-6517fc99b07a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Jun's",
      "poi_type": "Restaurants",
      "poi_address": "7660 State Line Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "Simple Japanese restaurant with a welcoming atmosphere, a sushi bar & tatami rooms.",
      "poi_long_description": "Simple Japanese restaurant with a welcoming atmosphere, a sushi bar & tatami rooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-c920-7047-9bf1-bb7f0b4eed34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-c920-7047-9bf1-bb7f0b4eed34",
        "storage_key": "property/6767906449167589/01a0101d-c920-7047-9bf1-bb7f0b4eed34.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kansascityjuns.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11799489471090071601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "juns",
      "poi_latitude": "38.9891027",
      "poi_longitude": "-94.6096095",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-341-4924",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKUn-rtTuwIcRMRhJVyg1wKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_b2fbe813-baad-4352-8f9a-c197ebc302e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Penny’s in the Village",
      "poi_type": "Restaurants",
      "poi_address": "4160 W 71st St, Prairie Village, KS 66208, USA",
      "poi_short_description": "Relaxed, welcoming Thai eatery and bar showcasing a variety of street eats, curries and pad thai.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019ff6c8-a138-7114-8c6e-7b9af1083f8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-a138-7114-8c6e-7b9af1083f8e",
        "storage_key": "property/6767906449167589/019ff6c8-a138-7114-8c6e-7b9af1083f8e.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://pennysinthevillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3810517811341420304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennys-in-the-village",
      "poi_latitude": "39.0007843",
      "poi_longitude": "-94.6328076",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-415-2330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkzkNF17vwIcREOdNq8Kt4TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_8050adaf-51ac-464c-8d6c-581a6de20707",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Minsky's",
      "poi_type": "Restaurants",
      "poi_address": "6921 Tomahawk Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "Elevated pizzeria chain with lots of crust & topping options, plus spaghetti & cheesesteaks.",
      "poi_long_description": "Elevated pizzeria chain with lots of crust & topping options, plus spaghetti & cheesesteaks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-7865-76eb-a316-86ee062d61fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-7865-76eb-a316-86ee062d61fd",
        "storage_key": "property/6767906449167589/019fc924-7865-76eb-a316-86ee062d61fd.webp",
        "width": 1280,
        "height": 893
      },
      "poi_business_url": "http://www.minskys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15621581521540643237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minskys",
      "poi_latitude": "39.0033454",
      "poi_longitude": "-94.6314044",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-262-6226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz3_jo5buwIcRpXk8jaABy9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_e88032cc-6e17-43f5-8f7e-333f97cb44e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Dolce Bakery",
      "poi_type": "Restaurants",
      "poi_address": "3930 W 69th Terrace, Prairie Village, KS 66208, USA",
      "poi_short_description": "Scratch-made breakfast pastries, cakes, cookies & other treats offered in a rustic-chic setting.",
      "poi_long_description": "Scratch-made breakfast pastries, cakes, cookies & other treats offered in a rustic-chic setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019ff6c8-a170-7443-a221-bfb7b58a844c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-a170-7443-a221-bfb7b58a844c",
        "storage_key": "property/6767906449167589/019ff6c8-a170-7443-a221-bfb7b58a844c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.dolcebakes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4245454142905409688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dolce-bakery",
      "poi_latitude": "39.0025097",
      "poi_longitude": "-94.6313884",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-236-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9gkdJbuwIcRmGAWsgzi6jo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_28bc03a8-a51a-43ed-aeda-bccee9c68992",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Hattie's Fine Coffee",
      "poi_type": "Restaurants",
      "poi_address": "4195 Somerset Dr, Prairie Village, KS 66208, USA",
      "poi_short_description": "Cozy java joint for specialty drinks and homemade pastries, along with light dishes and sandwiches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-7ca4-7088-9533-0a44d1eafe4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-7ca4-7088-9533-0a44d1eafe4a",
        "storage_key": "property/6767906449167589/019fc924-7ca4-7088-9533-0a44d1eafe4a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://hattiescoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14870662979620337828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hatties-fine-coffee",
      "poi_latitude": "38.980602",
      "poi_longitude": "-94.633172",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-648-2326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-e7df-753c-979d-581fe289b15e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-e7df-753c-979d-581fe289b15e",
        "storage_key": "property/6767906449167589/019fc924-e7df-753c-979d-581fe289b15e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJxYVA67LuwIcRpHjSGjE1X84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_23ee5b9e-d107-4541-bbbb-16f73717dd7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Rise Southern Biscuits & Righteous Chicken - Prairie Village",
      "poi_type": "Restaurants",
      "poi_address": "6947 Tomahawk Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "Comfort food such as biscuits, donuts, and chicken in a relaxed setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-7790-74c0-a18f-f46eebd8daee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-7790-74c0-a18f-f46eebd8daee",
        "storage_key": "property/6767906449167589/019fc924-7790-74c0-a18f-f46eebd8daee.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.risebiscuitsdonuts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3839676118871777204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rise-southern-biscuits--righteous-chicken---prairie-village",
      "poi_latitude": "39.0028492",
      "poi_longitude": "-94.6318252",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-320-0178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWhn1rbvwIcRtB_nLRZFSTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a67294e9-f06d-4909-98bf-b6c4f5909342",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "BRGR Kitchen + Bar",
      "poi_type": "Restaurants",
      "poi_address": "4038 W 83rd St, Prairie Village, KS 66208, USA",
      "poi_short_description": "Upscale burgers & fries star at this American option with an industrial vibe & patio seats.",
      "poi_long_description": "Upscale burgers & fries star at this American option with an industrial vibe & patio seats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-c8a7-75c9-a9b7-131aaa5b801f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-c8a7-75c9-a9b7-131aaa5b801f",
        "storage_key": "property/6767906449167589/01a0101d-c8a7-75c9-a9b7-131aaa5b801f.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "https://brgrkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1491516546668878135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brgr-kitchen--bar",
      "poi_latitude": "38.9796683",
      "poi_longitude": "-94.6322001",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-825-2747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY6OpKE3pwIcRN9nQlGXushQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f847ee22-5ad9-4978-ba5c-4b518b665fe0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Big Grove - Prairie Village",
      "poi_type": "Restaurants",
      "poi_address": "7060 Mission Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-cfee-742a-a2f1-1fa786ba9f89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-cfee-742a-a2f1-1fa786ba9f89",
        "storage_key": "property/6767906449167589/01a0101d-cfee-742a-a2f1-1fa786ba9f89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://biggrove.com/pages/prairie-village-taproom",
      "poi_directions_map_url": "https://maps.google.com/?cid=14743865958831009642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-grove---prairie-village",
      "poi_latitude": "39.0011445",
      "poi_longitude": "-94.6307102",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-431-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhduZivHvwIcRaq8YJPm7nMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_47ba3610-7183-4a10-8e9c-2e8767fd650f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Playa Bowls",
      "poi_type": "Restaurants",
      "poi_address": "6927 Tomahawk Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-821c-72fd-8e18-158c4139ef34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-821c-72fd-8e18-158c4139ef34",
        "storage_key": "property/6767906449167589/019fc924-821c-72fd-8e18-158c4139ef34.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://playabowls.com/location/prairie-villagee",
      "poi_directions_map_url": "https://maps.google.com/?cid=13896728629762024376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "playa-bowls",
      "poi_latitude": "39.0032126",
      "poi_longitude": "-94.6314104",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-261-9308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwDJvt_vwIcRuGP3jA8Z28A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_dfcfa52d-4509-400e-a58e-be04c5b2906a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Einstein Bros. Bagels",
      "poi_type": "Restaurants",
      "poi_address": "6970 Mission Rd Ste 36, Prairie Village, KS 66208, USA",
      "poi_short_description": "Neighborhood chain offering a menu of bagels and sandwiches, plus coffee.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-cb30-775e-9a0a-cd8fd3178052.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-cb30-775e-9a0a-cd8fd3178052",
        "storage_key": "property/6767906449167589/01a0101d-cb30-775e-9a0a-cd8fd3178052.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.einsteinbros.com/us/ks/prairie-village/6970-mission-rd?y_source=1_OTA1MDA1OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14978420395878151099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "einstein-bros-bagels",
      "poi_latitude": "39.00203399999999",
      "poi_longitude": "-94.6300523",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-906-8728",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAbq-kZbuwIcRu3PIsP0J3s8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "custom_a1bf356f-15a9-41be-932c-9961f00c3069",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Clementine's Ice Cream",
      "poi_type": "Restaurants",
      "poi_address": "6966 Mission Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-7aaf-775e-959b-463b20c2e758.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-7aaf-775e-959b-463b20c2e758",
        "storage_key": "property/6767906449167589/019fc924-7aaf-775e-959b-463b20c2e758.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.clementinescreamery.com/pages/prairie-village?utm_source=gmb&utm_medium=organic&utm_content=gmb-website",
      "poi_directions_map_url": "https://maps.google.com/?cid=1945418027920723150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clementines-ice-cream",
      "poi_latitude": "39.00201819999999",
      "poi_longitude": "-94.6298823",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-608-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-33591a1261ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-33591a1261ce",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-33591a1261ce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3TKJx_nvwIcRzgzbnWOD_xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_48fa6789-6c3b-4063-bdcb-c0cb6b852ff2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "7000 W 75th St, Overland Park, KS 66204, USA",
      "poi_short_description": "Chain grocery store selling produce, organic products, and prepared foods, plus a deli, bakery, and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-893c-71ba-82d1-24c4fbe3fd98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-893c-71ba-82d1-24c4fbe3fd98",
        "storage_key": "property/6767906449167589/019fc924-893c-71ba-82d1-24c4fbe3fd98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mypricechopper.com/store-details?storeId=66",
      "poi_directions_map_url": "https://maps.google.com/?cid=12038232150813892662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "price-chopper",
      "poi_latitude": "38.9938377",
      "poi_longitude": "-94.665339",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-432-1107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb9e-7576-81f3-1b71a9e16442.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb9e-7576-81f3-1b71a9e16442",
        "storage_key": "property/6767906449167589/019fc921-fb9e-7576-81f3-1b71a9e16442.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkZ3AVGvswIcRNuDyIFxkEKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0f9c3ff9-aacd-4426-a380-695b1bc285bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "7500 Metcalf Ave Walgreens, Overland Park, KS 66204, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-8b19-751f-b7ef-69868df074b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-8b19-751f-b7ef-69868df074b7",
        "storage_key": "property/6767906449167589/019fc924-8b19-751f-b7ef-69868df074b7.webp",
        "width": 1280,
        "height": 767
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-7500+metcalf+ave-overland+park-ks-66204/id=4234",
      "poi_directions_map_url": "https://maps.google.com/?cid=15380720365872010384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.9926082",
      "poi_longitude": "-94.6682884",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-341-1725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WJUj2zswIcRkNRqpa5Lc9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_34c18050-aff7-4a14-90c3-2d7adba3132b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Hen House",
      "poi_type": "Shopping & Retail",
      "poi_address": "6950 Mission Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "Compact market chain featuring a bakery and pharmacy, plus sushi and a salad bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-86ee-72ba-81c4-64ca3a94038f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-86ee-72ba-81c4-64ca3a94038f",
        "storage_key": "property/6767906449167589/019fc924-86ee-72ba-81c4-64ca3a94038f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://henhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18191455318328823447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hen-house",
      "poi_latitude": "39.0027385",
      "poi_longitude": "-94.6308245",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-362-3556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb9e-7576-81f3-1b71a9e16442.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb9e-7576-81f3-1b71a9e16442",
        "storage_key": "property/6767906449167589/019fc921-fb9e-7576-81f3-1b71a9e16442.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt2WiYZbuwIcRl05hxDoIdfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b28e5da3-f4d5-4e3a-a2a5-1919a69ddb1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Walmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "7701 Frontage Rd, Overland Park, KS 66204, USA",
      "poi_short_description": "Grocery and household goods are sold at this store, which also provides pharmacy services and optometric care.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-caa8-715d-8e0f-dfb8f14dac96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-caa8-715d-8e0f-dfb8f14dac96",
        "storage_key": "property/6767906449167589/01a0101d-caa8-715d-8e0f-dfb8f14dac96.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1691-overland-park-ks?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16580119918847404756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart",
      "poi_latitude": "38.9896418",
      "poi_longitude": "-94.6988084",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-648-5885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-33591a1261ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-33591a1261ce",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-33591a1261ce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7Vm5UZDswIcR1CpHkDhrGOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_451c487a-17f3-45fc-b0ef-957a6dcc7b28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "La Mexicanita",
      "poi_type": "Shopping & Retail",
      "poi_address": "7620 Metcalf Ave, Overland Park, KS 66204, USA",
      "poi_short_description": "Grocery store in Oakbrook Plaza offering fresh produce.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-cd99-74c6-8108-e9d8fd55a57d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-cd99-74c6-8108-e9d8fd55a57d",
        "storage_key": "property/6767906449167589/01a0101d-cd99-74c6-8108-e9d8fd55a57d.webp",
        "width": 982,
        "height": 1280
      },
      "poi_business_url": "https://mexicanametcalf.wixsite.com/mexicanita",
      "poi_directions_map_url": "https://maps.google.com/?cid=3883881065203159512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-mexicanita",
      "poi_latitude": "38.9901931",
      "poi_longitude": "-94.6680924",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-383-2578",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-eca4-72f7-adc5-de84d3e7a588.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0101d-eca4-72f7-adc5-de84d3e7a588",
        "storage_key": "property/6767906449167589/01a0101d-eca4-72f7-adc5-de84d3e7a588.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJC9FZBm3swIcR2NFMSUBR5jU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_921ab9b7-773d-4d4d-a645-55cd6164ba8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "8501 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Supermarket with fresh and organic produce as well as a bakery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-ceb6-70a2-8035-a516fd40f70d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-ceb6-70a2-8035-a516fd40f70d",
        "storage_key": "property/6767906449167589/01a0101d-ceb6-70a2-8035-a516fd40f70d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=128&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11669836886695708453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "38.955555",
      "poi_longitude": "-94.683945",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-894-1983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb9e-7576-81f3-1b71a9e16442.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb9e-7576-81f3-1b71a9e16442",
        "storage_key": "property/6767906449167589/019fc921-fb9e-7576-81f3-1b71a9e16442.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xEOmOzrwIcRJYc_qtGW86E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_67ec2cb1-ae4e-4fdd-b3cd-51e76c5137a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Trader Joe’s",
      "poi_type": "Shopping & Retail",
      "poi_address": "8700 Shawnee Mission Pkwy, Merriam, KS 66202, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-cd32-72f1-b6c5-5aa42c7e3376.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-cd32-72f1-b6c5-5aa42c7e3376",
        "storage_key": "property/6767906449167589/01a0101d-cd32-72f1-b6c5-5aa42c7e3376.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/KS/Merriam/821/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7457331268291405700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "39.0155022",
      "poi_longitude": "-94.68678210000002",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb9e-7576-81f3-1b71a9e16442.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb9e-7576-81f3-1b71a9e16442",
        "storage_key": "property/6767906449167589/019fc921-fb9e-7576-81f3-1b71a9e16442.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WUFXQDtwIcRhCfsIkfDfWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f33cd4a8-3b2e-487f-a3d8-13f3c4c14a78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Firehouse Subs Met 75 Shops",
      "poi_type": "Restaurants",
      "poi_address": "6901 W 75th St, Overland Park, KS 66204, USA",
      "poi_short_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_long_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.firehousesubs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15338423108600989679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firehouse-subs-met-75-shops",
      "poi_latitude": "38.99249409999999",
      "poi_longitude": "-94.6654201",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-549-3005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ91k_aQDtwIcR7wfOAo0G3dQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_53680ed8-529d-4eb8-bf23-b6d9f7e70ffc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Meineke Car Care Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7525 Metcalf Ave, Overland Park, KS 66204, USA",
      "poi_short_description": "Chain auto repair center offering services such as oil changes, tire installation, and muffler repair.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-cf26-70fe-aa87-15c652d7ab71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-cf26-70fe-aa87-15c652d7ab71",
        "storage_key": "property/6767906449167589/01a0101d-cf26-70fe-aa87-15c652d7ab71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.meineke.com/locations/ks/overland-park-1377/?utm_source=google&utm_medium=organic&utm_campaign=gbp_website",
      "poi_directions_map_url": "https://maps.google.com/?cid=7415169177225313668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meineke-car-care-center",
      "poi_latitude": "38.992178",
      "poi_longitude": "-94.667013",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-871-9764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30PLj2zswIcRhL3wVRT552Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_repair"
    },
    {
      "id": "custom_3b6ed404-2b0f-4c9a-8095-d8ab9a0614f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Asbury Children Center",
      "poi_type": "Education",
      "poi_address": "5400 W 75th St, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://visitasbury.org/childrens-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11602481791297139911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asbury-children-center",
      "poi_latitude": "38.993536",
      "poi_longitude": "-94.647446",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-677-5008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4e-7598-8fde-61240bfd1f64",
        "storage_key": "property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqX9XzB3swIcRxzQ0c7dLBKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_a3fa5859-f15f-4422-bb06-a3c67a852434",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "The Owl's Nest",
      "poi_type": "Education",
      "poi_address": "5407 W 75th St, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-d490-7349-9f3b-82558ea344d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-d490-7349-9f3b-82558ea344d0",
        "storage_key": "property/6767906449167589/01a0101d-d490-7349-9f3b-82558ea344d0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://owlsnestpv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6441996963396817985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-owls-nest",
      "poi_latitude": "38.9925577",
      "poi_longitude": "-94.64806740000002",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-948-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4e-7598-8fde-61240bfd1f64",
        "storage_key": "property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8eky1evtwIcRQZRpZxuSZlk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_a0067955-0987-49ed-a0bc-740cdf01964b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Indian Hills Middle School",
      "poi_type": "Education",
      "poi_address": "6400 Mission Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-916b-7028-8aa8-52b182607be9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-916b-7028-8aa8-52b182607be9",
        "storage_key": "property/6767906449167589/019fc924-916b-7028-8aa8-52b182607be9.webp",
        "width": 1280,
        "height": 820
      },
      "poi_business_url": "https://indianhills.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15560720076340200164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-hills-middle-school",
      "poi_latitude": "39.0139969",
      "poi_longitude": "-94.6317585",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-993-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4e-7598-8fde-61240bfd1f64",
        "storage_key": "property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjbfaHI_uwIcR5AKMF3fI8tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f49593b6-8113-4e53-a649-909d275936de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Prairie Elementary School",
      "poi_type": "Education",
      "poi_address": "6642 Mission Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-91b6-75b8-b938-559c36aa8f8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-91b6-75b8-b938-559c36aa8f8c",
        "storage_key": "property/6767906449167589/019fc924-91b6-75b8-b938-559c36aa8f8c.webp",
        "width": 1280,
        "height": 696
      },
      "poi_business_url": "http://prairie.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10391531110873280747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-elementary-school",
      "poi_latitude": "39.008491",
      "poi_longitude": "-94.6309221",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-993-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4e-7598-8fde-61240bfd1f64",
        "storage_key": "property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB8AFU5DuwIcR67AFGH0iNpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_400070c5-d4d2-40e9-bc29-626de26b2082",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Belinder Elementary School",
      "poi_type": "Education",
      "poi_address": "7230 Belinder Ave, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-95bf-77cc-981a-13d735d12d01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-95bf-77cc-981a-13d735d12d01",
        "storage_key": "property/6767906449167589/019fc924-95bf-77cc-981a-13d735d12d01.webp",
        "width": 1280,
        "height": 787
      },
      "poi_business_url": "http://belinder.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7831950692182636159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belinder-elementary-school",
      "poi_latitude": "38.9977694",
      "poi_longitude": "-94.6171226",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-993-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4e-7598-8fde-61240bfd1f64",
        "storage_key": "property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_8J7s8PuwIcRf7bruaitsGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_78444c68-27bd-434a-a10f-3a8b49e6fcb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "St. Ann Catholic School",
      "poi_type": "Education",
      "poi_address": "7241 Mission Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-9428-7516-b7ad-3ee2f5f5cc80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-9428-7516-b7ad-3ee2f5f5cc80",
        "storage_key": "property/6767906449167589/019fc924-9428-7516-b7ad-3ee2f5f5cc80.webp",
        "width": 1280,
        "height": 939
      },
      "poi_business_url": "http://school.stannpv.org",
      "poi_directions_map_url": "https://maps.google.com/?cid=7137263629041532800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-ann-catholic-school",
      "poi_latitude": "38.997172",
      "poi_longitude": "-94.629662",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-660-1101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4e-7598-8fde-61240bfd1f64",
        "storage_key": "property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH7buL7zuwIcRgP9VrXSnDGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8cd87da2-17ee-4ad0-8056-a1f230c4ea15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Shawnee Mission East High School",
      "poi_type": "Education",
      "poi_address": "7500 Mission Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-8fda-7472-9629-b60fc564355b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-8fda-7472-9629-b60fc564355b",
        "storage_key": "property/6767906449167589/019fc924-8fda-7472-9629-b60fc564355b.webp",
        "width": 1280,
        "height": 645
      },
      "poi_business_url": "https://smeast.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15211844973606928147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-mission-east-high-school",
      "poi_latitude": "38.9918846",
      "poi_longitude": "-94.6313195",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-993-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4e-7598-8fde-61240bfd1f64",
        "storage_key": "property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzZ2rNrruwIcRE_8mXmhUG9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_e5aa64c3-d01d-456d-9780-a03995fccd48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Kansas City Christian School",
      "poi_type": "Education",
      "poi_address": "4801 W 79th St, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kcchristianschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5565152380020795199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-christian-school",
      "poi_latitude": "38.9854781",
      "poi_longitude": "-94.6414673",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-648-5227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4e-7598-8fde-61240bfd1f64",
        "storage_key": "property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwTyRbanuwIcRPycPrJpkO00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e1e30673-8527-4e3b-a713-084b6995f10c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Briarwood Elementary School",
      "poi_type": "Education",
      "poi_address": "5300 W 86th St, Prairie Village, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-9987-714f-80ec-a8c7d4943cd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-9987-714f-80ec-a8c7d4943cd8",
        "storage_key": "property/6767906449167589/019fc924-9987-714f-80ec-a8c7d4943cd8.webp",
        "width": 1280,
        "height": 817
      },
      "poi_business_url": "https://briarwood.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8899338515248315372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "briarwood-elementary-school",
      "poi_latitude": "38.9739127",
      "poi_longitude": "-94.6465547",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-993-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4e-7598-8fde-61240bfd1f64",
        "storage_key": "property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2Tsncv7rwIcR7PtTmTrNgHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9a9ca033-0423-41b7-a759-96657ef0bc88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-cc84-733a-8b49-33e116401f09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc921-cc84-733a-8b49-33e116401f09",
        "storage_key": "property/6767906449167589/019fc921-cc84-733a-8b49-33e116401f09.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4e-7598-8fde-61240bfd1f64",
        "storage_key": "property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0b888c16-5992-462c-b74f-a2465184ace9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "The Market at Meadowbrook",
      "poi_type": "Restaurants",
      "poi_address": "4901 Meadowbrook Pkwy, Prairie Village, KS 66207, USA",
      "poi_short_description": "Casual cafe serving familiar sandwiches and salads alongside beer, wine and desserts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-d62d-735d-9ca9-5a024e204aa1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-d62d-735d-9ca9-5a024e204aa1",
        "storage_key": "property/6767906449167589/01a0101d-d62d-735d-9ca9-5a024e204aa1.webp",
        "width": 960,
        "height": 1118
      },
      "poi_business_url": "https://themarketkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13788754226868499526&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-market-at-meadowbrook",
      "poi_latitude": "38.961174",
      "poi_longitude": "-94.6435317",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-329-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkcjCUTrpwIcRRrSp0-l-W78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fff518ec-b17d-44ed-a185-0bf2ee67c299",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Nerman Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_long_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-9d1f-7626-8ae5-316662694d1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-9d1f-7626-8ae5-316662694d1d",
        "storage_key": "property/6767906449167589/019fc924-9d1f-7626-8ae5-316662694d1d.webp",
        "width": 1080,
        "height": 830
      },
      "poi_business_url": "http://www.nermanmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4973184191241098516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nerman-museum-of-contemporary-art",
      "poi_latitude": "38.924852",
      "poi_longitude": "-94.726824",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-469-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb53-71c5-af59-1060c5eb128b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb53-71c5-af59-1060c5eb128b",
        "storage_key": "property/6767906449167589/019fc921-fb53-71c5-af59-1060c5eb128b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRFJWDQaxMBEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_9bf8a653-bb2e-4959-a396-47e8517d9e2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Overland Park Arboretum & Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8909 W 179th St, Overland Park, KS 66013, USA",
      "poi_short_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_long_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-d6f0-709e-a10e-18858a754473.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-d6f0-709e-a10e-18858a754473",
        "storage_key": "property/6767906449167589/01a0101d-d6f0-709e-a10e-18858a754473.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/recreation-fun/arboretum-botanical-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713039177416778041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-arboretum--botanical-gardens",
      "poi_latitude": "38.8033925",
      "poi_longitude": "-94.6891159",
      "poi_miles_from_property": "14.6",
      "poi_walking_minutes": "5 hours 23 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 913-685-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6csjvynHwIcROSH92_fu6ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_b3dd6302-38ec-48ef-b163-cc7fdba909a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-9d2f-73df-9454-aef98dd11aab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-9d2f-73df-9454-aef98dd11aab",
        "storage_key": "property/6767906449167589/019fc924-9d2f-73df-9454-aef98dd11aab.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb53-71c5-af59-1060c5eb128b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb53-71c5-af59-1060c5eb128b",
        "storage_key": "property/6767906449167589/019fc921-fb53-71c5-af59-1060c5eb128b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_95935e9d-dbe1-4c8d-9516-d81ef20cad8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "AMC Prairiefire 17",
      "poi_type": "Entertainment",
      "poi_address": "5724 W 136th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Comfortable entertainment venue featuring a full menu alongside movie screenings of new releases.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-9b27-72a8-8d86-63f8767b203d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-9b27-72a8-8d86-63f8767b203d",
        "storage_key": "property/6767906449167589/019fc924-9b27-72a8-8d86-63f8767b203d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-prairiefire-17?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3727223515720771879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-prairiefire-17",
      "poi_latitude": "38.8826984",
      "poi_longitude": "-94.651566",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 913-553-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-e7f4-77fc-9606-c0f21db1ab26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-e7f4-77fc-9606-c0f21db1ab26",
        "storage_key": "property/6767906449167589/019fc924-e7f4-77fc-9606-c0f21db1ab26.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fXu5_DBwIcRJ-kENQrCuTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_e385545c-6ea0-415b-9dcb-2b4322a7e6c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "5901 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly venue with pickleball courts and other games, plus a casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-a02e-755d-84ae-d001fc8ef967.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-a02e-755d-84ae-d001fc8ef967",
        "storage_key": "property/6767906449167589/019fc924-a02e-755d-84ae-d001fc8ef967.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904135511973972812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---overland-park",
      "poi_latitude": "38.8830518",
      "poi_longitude": "-94.6552102",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 913-703-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9D8rijBwIcRTEsyKpBGLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_730201d2-79d9-4173-8a67-26e1c29456c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Rock & Brews",
      "poi_type": "Restaurants",
      "poi_address": "5701 W 135th St, Overland Park, KS 66224, USA",
      "poi_short_description": "Brewery and chain of American grill eats such as burgers, hot wings, tacos, and pulled pork, plus a dog-friendly patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-d693-7211-b0df-4a9dfb931e2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-d693-7211-b0df-4a9dfb931e2f",
        "storage_key": "property/6767906449167589/01a0101d-d693-7211-b0df-4a9dfb931e2f.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://www.rockandbrews.com/overlandpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=15053523993570692724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock--brews",
      "poi_latitude": "38.8832498",
      "poi_longitude": "-94.651677",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 913-544-1113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-ce0bd0c8d8e0",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-ce0bd0c8d8e0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99afOPfBwIcRdM6ZrlDc6NA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_87382ba7-a444-432e-a5a3-c34608161757",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "810 Entertainment - Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "13500 Nall Ave, Overland Park, KS 66224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019ff6c8-bd73-738c-b6f7-dd30274d4b4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-bd73-738c-b6f7-dd30274d4b4a",
        "storage_key": "property/6767906449167589/019ff6c8-bd73-738c-b6f7-dd30274d4b4a.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://810bowling.com/810-entertainment-overland-park-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=11623012279752903673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "810-entertainment---overland-park",
      "poi_latitude": "38.8828352",
      "poi_longitude": "-94.6497927",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 913-600-7088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ298S-n_BwIcR-cusShY8TaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_52fb3282-df10-41fc-8b7f-591fc1d0d8e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "BRKTHROUGH Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "6403 W 135th St Ste E4, Overland Park, KS 66223, USA",
      "poi_short_description": "Social gaming venue at Corbin Park offering mental, physical, and skill-based challenges, plus dining.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019ff6c8-bb24-77e8-b549-997f15c00894.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-bb24-77e8-b549-997f15c00894",
        "storage_key": "property/6767906449167589/019ff6c8-bb24-77e8-b549-997f15c00894.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brkthrough.com/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18381408078784845033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brkthrough-overland-park",
      "poi_latitude": "38.8806486",
      "poi_longitude": "-94.659253",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 913-948-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ45a5JQXBwIcR6VR3P0LhF_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_66118823-ade4-4e4f-9c74-931413ac8f34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "The National Museum of Toys and Miniatures",
      "poi_type": "Entertainment",
      "poi_address": "5235 Oak St, Kansas City, MO 64112, USA",
      "poi_short_description": "Eclectic array of collectible toys, antique marbles & miniature reproductions of fine furnishings.",
      "poi_long_description": "Eclectic array of collectible toys, antique marbles & miniature reproductions of fine furnishings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-d9b5-7778-8948-4b57cf7a2c4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc921-d9b5-7778-8948-4b57cf7a2c4b",
        "storage_key": "property/6767906449167589/019fc921-d9b5-7778-8948-4b57cf7a2c4b.webp",
        "width": 1280,
        "height": 1014
      },
      "poi_business_url": "http://www.toyandminiaturemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3778476980352128529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-national-museum-of-toys-and-miniatures",
      "poi_latitude": "39.0307741",
      "poi_longitude": "-94.5820813",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-235-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb53-71c5-af59-1060c5eb128b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb53-71c5-af59-1060c5eb128b",
        "storage_key": "property/6767906449167589/019fc921-fb53-71c5-af59-1060c5eb128b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLdcuZ5jvwIcRERbhXcvYbzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_bf4620c3-1061-467b-b317-c2bdb20a7e00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "AdventHealth Shawnee Mission",
      "poi_type": "Health and Wellness",
      "poi_address": "9100 W 74th St, Merriam, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-a218-7301-99aa-dc0883a5cb9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-a218-7301-99aa-dc0883a5cb9b",
        "storage_key": "property/6767906449167589/019fc924-a218-7301-99aa-dc0883a5cb9b.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-shawnee-mission",
      "poi_directions_map_url": "https://maps.google.com/?cid=13000316506480230417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-shawnee-mission",
      "poi_latitude": "38.9954504",
      "poi_longitude": "-94.6921104",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-676-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb67-7339-9551-ff8a96d45c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb67-7339-9551-ff8a96d45c58",
        "storage_key": "property/6767906449167589/019fc921-fb67-7339-9551-ff8a96d45c58.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJDc_MeIvswIcREcBm6PtmarQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2e2c8255-25b2-47f2-afb6-f683bcfa3407",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Saint Luke's South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12300 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-d95b-71a9-8c8f-2b0cbb5827ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-d95b-71a9-8c8f-2b0cbb5827ca",
        "storage_key": "property/6767906449167589/01a0101d-d95b-71a9-8c8f-2b0cbb5827ca.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-south-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966224544508452770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-south-hospital",
      "poi_latitude": "38.9041982",
      "poi_longitude": "-94.6695167",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 913-317-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb67-7339-9551-ff8a96d45c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb67-7339-9551-ff8a96d45c58",
        "storage_key": "property/6767906449167589/019fc921-fb67-7339-9551-ff8a96d45c58.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT2aF3LqwIcRop_Q17dtbnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_0af844be-0db5-4b12-9dd3-e48a56a878a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Prairie Village",
      "poi_type": "Health and Wellness",
      "poi_address": "6930 Mission Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-a174-772b-ba4b-2531d54931e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-a174-772b-ba4b-2531d54931e1",
        "storage_key": "property/6767906449167589/019fc924-a174-772b-ba4b-2531d54931e1.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.carenow.com/locations/kansas-city/prairie-village?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8932124204898545431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---prairie-village",
      "poi_latitude": "39.0030251",
      "poi_longitude": "-94.6297888",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-401-2440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9SYFxmTvwIcRF2-l0qNH9Xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_9fca4c79-5e9e-4a6b-9341-addb6d575c87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "7501 Metcalf Ave, Overland Park, KS 66204, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-d9b1-765c-8f0b-9c4770734b50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-d9b1-765c-8f0b-9c4770734b50",
        "storage_key": "property/6767906449167589/01a0101d-d9b1-765c-8f0b-9c4770734b50.webp",
        "width": 936,
        "height": 800
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/7501-metcalf-ave-overland-park-ks-66204/storeid=8602?WT.mc_id=LS_GOOGLE_FS_8602",
      "poi_directions_map_url": "https://maps.google.com/?cid=13819622875502458664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "38.99266",
      "poi_longitude": "-94.66672",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-642-6330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhdsgvGzswIcRKLcvKMkpyb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_c12df445-0c7c-4acc-8548-3997f822e26f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7500 Metcalf Ave, Overland Park, KS 66204, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-dbaa-775f-8a2b-d0c9402b5a18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-dbaa-775f-8a2b-d0c9402b5a18",
        "storage_key": "property/6767906449167589/01a0101d-dbaa-775f-8a2b-d0c9402b5a18.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-7500+metcalf+ave-overland+park-ks-66204/id=4234",
      "poi_directions_map_url": "https://maps.google.com/?cid=10498892565236298918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "38.9925621",
      "poi_longitude": "-94.6683005",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-341-1725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-e807-76db-9001-e9fb35ac6e28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-e807-76db-9001-e9fb35ac6e28",
        "storage_key": "property/6767906449167589/019fc924-e807-76db-9001-e9fb35ac6e28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2w3-iWzswIcRpjTmnSmPs5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3ee453fe-7255-41da-8d49-2c3b273bc5f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Paul Henson Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "4200 W 79th St, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-a489-7055-8c78-33d8d898c86d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-a489-7055-8c78-33d8d898c86d",
        "storage_key": "property/6767906449167589/019fc924-a489-7055-8c78-33d8d898c86d.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://kansascityymca.org/locations/paul-henson",
      "poi_directions_map_url": "https://maps.google.com/?cid=16712717198438999330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paul-henson-family-ymca",
      "poi_latitude": "38.9863829",
      "poi_longitude": "-94.6337651",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-642-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG0dJxrHuwIcRIqWEhL5_7-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_34c2ff88-9578-4486-aa87-e70fae4b6cc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "3905 W 83rd St, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-a5a6-76df-aa19-4edf2d757ec3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-a5a6-76df-aa19-4edf2d757ec3",
        "storage_key": "property/6767906449167589/019fc924-a5a6-76df-aa19-4edf2d757ec3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/location/prairievillage/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=6699056930940587557&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "38.9781834",
      "poi_longitude": "-94.6310825",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-674-8609",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4e-7598-8fde-61240bfd1f64",
        "storage_key": "property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT32esKrpwIcRJQ7VGsnU91w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d763eb0a-0e6b-4a4c-936a-332fef97988c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Power Life Yoga Barre Fitness - Corinth Square",
      "poi_type": "Health and Wellness",
      "poi_address": "4145 Somerset Dr, Prairie Village, KS 66208, USA",
      "poi_short_description": "Chain studio offering a range of yoga classes for beginners and experienced practitioners alike.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-dc98-706a-bfd5-e804bb692bbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-dc98-706a-bfd5-e804bb692bbe",
        "storage_key": "property/6767906449167589/01a0101d-dc98-706a-bfd5-e804bb692bbe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://powerlife.com/location/corinth-square/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3125544932140217938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "power-life-yoga-barre-fitness---corinth-square",
      "poi_latitude": "38.9806024",
      "poi_longitude": "-94.6328232",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-642-2512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdaZcwrLuwIcRUna9UY4qYCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_a29581f6-0a17-47a0-a936-253fcd6ea0c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "BODY20",
      "poi_type": "Health and Wellness",
      "poi_address": "16962 City Center Dr, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-ddb1-708d-8c8c-f63534392787.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-ddb1-708d-8c8c-f63534392787",
        "storage_key": "property/6767906449167589/01a0101d-ddb1-708d-8c8c-f63534392787.webp",
        "width": 1062,
        "height": 686
      },
      "poi_business_url": "https://body20.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17878141664847906246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "body20",
      "poi_latitude": "38.9689767",
      "poi_longitude": "-94.7825915",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-259-7096",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUSctu3vwIcRxsVeKR_rG_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_2af1b0ab-13cc-4ae4-97df-25eee37d617f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "TITLE Boxing Club State Line",
      "poi_type": "Health and Wellness",
      "poi_address": "8029 State Line Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "Gym, part of a national chain, specializing in boxing and kickboxing classes for all ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-deac-7337-b587-5043b3362e6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-deac-7337-b587-5043b3362e6c",
        "storage_key": "property/6767906449167589/01a0101d-deac-7337-b587-5043b3362e6c.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://titleboxingclub.com/state-line-mo/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11965555399473340168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "title-boxing-club-state-line",
      "poi_latitude": "38.9820385",
      "poi_longitude": "-94.6076149",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-997-9777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4e-7598-8fde-61240bfd1f64",
        "storage_key": "property/6767906449167589/019fc921-fb4e-7598-8fde-61240bfd1f64.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVQIy4tnuwIcRCJ_dVT0xDqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_coaching"
    },
    {
      "id": "custom_e3f76874-6fc9-4cc4-ba74-b25b6c42a984",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Meadowbrook Park Clubhouse",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9101 Nall Ave, Prairie Village, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-dec7-77af-a285-91ecb740e246.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-dec7-77af-a285-91ecb740e246",
        "storage_key": "property/6767906449167589/01a0101d-dec7-77af-a285-91ecb740e246.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.jcprd.com/Facilities/Facility/Details/Meadowbrook-Park-98",
      "poi_directions_map_url": "https://maps.google.com/?cid=15274055935577880446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadowbrook-park-clubhouse",
      "poi_latitude": "38.9633102",
      "poi_longitude": "-94.6474593",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-826-2975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-d0dd364a4ff4",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPxXvbQDrwIcRfveQr_JY-NM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_235c4598-27e2-4050-ba4e-6133f9ed3fcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Harmon Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W 77th Pl &, Delmar St, Prairie Village, KS 66208, USA",
      "poi_short_description": "Family-friendly area with disc golf, tennis courts - including some with free lights - and a pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-a873-77f8-b316-ba91b08914d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-a873-77f8-b316-ba91b08914d1",
        "storage_key": "property/6767906449167589/019fc924-a873-77f8-b316-ba91b08914d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pvkansas.com/Home/Components/FacilityDirectory/FacilityDirectory/14/641",
      "poi_directions_map_url": "https://maps.google.com/?cid=2706299014673858140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harmon-park",
      "poi_latitude": "38.9880712",
      "poi_longitude": "-94.6335519",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-381-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-d0dd364a4ff4",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-3ZiP7DuwIcRXP6fgZ20jiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_376b301b-d418-4b7f-b785-938bbd73385c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "The Shops of Prairie Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "6950 Mission Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "Shopping center with a variety of stores including a pet store, urgent care facility, and eateries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-8b7a-719b-a0a8-15583e298a4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-8b7a-719b-a0a8-15583e298a4f",
        "storage_key": "property/6767906449167589/019fc924-8b7a-719b-a0a8-15583e298a4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shopsofprairievillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14361000661606159731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shops-of-prairie-village",
      "poi_latitude": "39.0027702",
      "poi_longitude": "-94.6309112",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-362-9668",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-33591a1261ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-33591a1261ce",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-33591a1261ce.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJibGIIZbuwIcRc1UvjgOGTMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c7275827-2ef7-4140-a596-ec8b1a2097ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Bennett Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5100 W 77th St, Prairie Village, KS 66208, USA",
      "poi_short_description": "Relaxed park with a sandbox, swings, a basketball half-court and a baseball field.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-a799-73d7-b28e-4f4f1d181a1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-a799-73d7-b28e-4f4f1d181a1d",
        "storage_key": "property/6767906449167589/019fc924-a799-73d7-b28e-4f4f1d181a1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pvkansas.com/Home/Components/FacilityDirectory/FacilityDirectory/2/641",
      "poi_directions_map_url": "https://maps.google.com/?cid=12436490007831559391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bennett-park",
      "poi_latitude": "38.989989",
      "poi_longitude": "-94.644733",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-381-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-d0dd364a4ff4",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55hc-afuwIcR37x-UcVJl6w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8528f38c-fd9a-4622-8829-abd4c5a96c0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Brenizer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-e0da-777a-97d2-5090ae68d032.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-e0da-777a-97d2-5090ae68d032",
        "storage_key": "property/6767906449167589/01a0101d-e0da-777a-97d2-5090ae68d032.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pvkansas.com/Home/Components/FacilityDirectory/FacilityDirectory/4/641",
      "poi_directions_map_url": "https://maps.google.com/?cid=1528762897784611503&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brenizer-park",
      "poi_latitude": "39.004037",
      "poi_longitude": "-94.6310912",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-381-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-d0dd364a4ff4",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFWQ56pbuwIcRr6I_fMFBNxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_10c95faa-32c3-4cb7-821b-95b3e99be079",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Franklin Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8700 Roe Ave, Prairie Village, KS 66207, USA",
      "poi_short_description": "Fitness trails in a woodsy setting with a playground, ball fields & a large picnic pavilion.",
      "poi_long_description": "Fitness trails in a woodsy setting with a playground, ball fields & a large picnic pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019ff6c8-d29a-70f1-b812-90b218166552.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-d29a-70f1-b812-90b218166552",
        "storage_key": "property/6767906449167589/019ff6c8-d29a-70f1-b812-90b218166552.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pvkansas.com/Home/Components/FacilityDirectory/FacilityDirectory/12/641",
      "poi_directions_map_url": "https://maps.google.com/?cid=3325055705952589482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "franklin-park",
      "poi_latitude": "38.9709693",
      "poi_longitude": "-94.6390481",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-381-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-d0dd364a4ff4",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVRlt11DpwIcRqpawM4z4JC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_25f5c8cb-865c-4db7-a2ba-bad75df2af58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Porter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4601 Tomahawk Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "Neighborhood park with a baseball diamond, grassy field, basketball courts, playground & BBQs.",
      "poi_long_description": "Neighborhood park with a baseball diamond, grassy field, basketball courts, playground & BBQs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-ad8b-765a-b00c-0165482b187b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-ad8b-765a-b00c-0165482b187b",
        "storage_key": "property/6767906449167589/019fc924-ad8b-765a-b00c-0165482b187b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pvkansas.com/Home/Components/FacilityDirectory/FacilityDirectory/22/641",
      "poi_directions_map_url": "https://maps.google.com/?cid=7253056474461931000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "porter-park",
      "poi_latitude": "38.9956788",
      "poi_longitude": "-94.6395465",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-381-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-d0dd364a4ff4",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuZQd7KPuwIcR-IUmaG8IqGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3f148a01-121d-4a47-be49-0b2c0caf9691",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Taliaferro Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2900 W 79th St, Prairie Village, KS 66208, USA",
      "poi_short_description": "Shaded playground featuring a tire swing, plus basketball, softball and tennis courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-ac50-76a7-a57d-4efb91ab52e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-ac50-76a7-a57d-4efb91ab52e4",
        "storage_key": "property/6767906449167589/019fc924-ac50-76a7-a57d-4efb91ab52e4.webp",
        "width": 1280,
        "height": 687
      },
      "poi_business_url": "https://www.pvkansas.com/Home/Components/FacilityDirectory/FacilityDirectory/34/641",
      "poi_directions_map_url": "https://maps.google.com/?cid=12720015666378313109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taliaferro-park",
      "poi_latitude": "38.986857",
      "poi_longitude": "-94.6193739",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-381-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-d0dd364a4ff4",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-GpM8nuwIcRlQ3i49qShrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_6cd161f9-2e62-400c-92ff-f8da8ea5a569",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Wassmer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4805 W 67th St, Prairie Village, KS 66208, USA",
      "poi_short_description": "City park with a playground, picnic tables, and BBQ grills, plus a memorial garden and zip line.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019ff6c8-d172-76c8-a84a-0533efa01916.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-d172-76c8-a84a-0533efa01916",
        "storage_key": "property/6767906449167589/019ff6c8-d172-76c8-a84a-0533efa01916.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pvkansas.com/departments/projects/wassmer-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8285938748811317955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wassmer-park",
      "poi_latitude": "39.0073003",
      "poi_longitude": "-94.6407168",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-381-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-d0dd364a4ff4",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2xhl3TvwIcRwxKLKWSR_XI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9038ec8e-4381-466b-87d3-edb9491fdba4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Shaffer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6840 Mission Rd, Prairie Village, KS 66208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-e1e6-732d-902c-66543f80c836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-e1e6-732d-902c-66543f80c836",
        "storage_key": "property/6767906449167589/01a0101d-e1e6-732d-902c-66543f80c836.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://pvkansas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16028776288466998708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shaffer-park",
      "poi_latitude": "39.0046194",
      "poi_longitude": "-94.6304863",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-381-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb4f-7269-8843-d0dd364a4ff4",
        "storage_key": "property/6767906449167589/019fc921-fb4f-7269-8843-d0dd364a4ff4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyfY9TwDvwIcRtJVHOhyncd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0713fbae-8fd1-43cf-af0c-54db0aaa9304",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-e7f1-718c-bada-2f1db7cf8fc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-e7f1-718c-bada-2f1db7cf8fc5",
        "storage_key": "property/6767906449167589/019fc924-e7f1-718c-bada-2f1db7cf8fc5.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_674fe90f-1d7b-4b28-a70f-89ea013218a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Oak Park Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16122160475460681538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park--ride",
      "poi_latitude": "38.9552209",
      "poi_longitude": "-94.7216049",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-e7f1-718c-bada-2f1db7cf8fc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-e7f1-718c-bada-2f1db7cf8fc5",
        "storage_key": "property/6767906449167589/019fc924-e7f1-718c-bada-2f1db7cf8fc5.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwpg4UnrwIcRQj-tl4hrvd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_09365137-10c1-4563-8ec4-89bd457f140c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Cosentino's Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "22210 W 66th St, Shawnee, KS 66226, USA",
      "poi_short_description": "Grocery outlet selling produce, meat, and organic products, plus prepared foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-e10c-74ee-ac6d-3349c2d92529.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-e10c-74ee-ac6d-3349c2d92529",
        "storage_key": "property/6767906449167589/01a0101d-e10c-74ee-ac6d-3349c2d92529.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mypricechopper.com/store-details?storeId=86",
      "poi_directions_map_url": "https://maps.google.com/?cid=5811553679194901116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-price-chopper",
      "poi_latitude": "39.0099101",
      "poi_longitude": "-94.843718",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 913-422-2130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb9e-7576-81f3-1b71a9e16442.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb9e-7576-81f3-1b71a9e16442",
        "storage_key": "property/6767906449167589/019fc921-fb9e-7576-81f3-1b71a9e16442.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ43RprQeRwIcRfMqGwUfJplA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2a9d7e48-597a-45d5-bb17-63fb0c9fa378",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Alphapointe",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7501 Prospect Ave, Kansas City, MO 64132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019ff6c8-d5bf-76be-a087-1ce7a5d513db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-d5bf-76be-a087-1ce7a5d513db",
        "storage_key": "property/6767906449167589/019ff6c8-d5bf-76be-a087-1ce7a5d513db.webp",
        "width": 1280,
        "height": 838
      },
      "poi_business_url": "http://www.alphapointe.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10019712522138751265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alphapointe",
      "poi_latitude": "38.98964429999999",
      "poi_longitude": "-94.5556366",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-421-5848",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYPjmPvlwIcRIRGdwXMrDYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_875ea3d7-a81b-4b7e-8163-ef8c097c1063",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "East Village Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 E 12th St, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-b47e-763c-9eb6-5c1e03c73091.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-b47e-763c-9eb6-5c1e03c73091",
        "storage_key": "property/6767906449167589/019fc924-b47e-763c-9eb6-5c1e03c73091.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "http://ridekc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16512695178041122718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-village-transit-center",
      "poi_latitude": "39.0994481",
      "poi_longitude": "-94.5736732",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 816-221-0660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVzzDLhPxwIcRnl9yw8bgKOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_cdd87980-c106-436c-8247-11fab4982617",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-b6e8-70d3-bd97-63fa26b78463.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-b6e8-70d3-bd97-63fa26b78463",
        "storage_key": "property/6767906449167589/019fc924-b6e8-70d3-bd97-63fa26b78463.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-e7f4-77fc-9606-bf9085bfafe5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-e7f4-77fc-9606-bf9085bfafe5",
        "storage_key": "property/6767906449167589/019fc924-e7f4-77fc-9606-bf9085bfafe5.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_65069ad9-6470-4ffc-bf0c-ba36fd19fdc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-b483-75c8-93b3-5260a1454c5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-b483-75c8-93b3-5260a1454c5c",
        "storage_key": "property/6767906449167589/019fc924-b483-75c8-93b3-5260a1454c5c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3014091",
      "poi_longitude": "-94.7104536",
      "poi_miles_from_property": "30.8",
      "poi_walking_minutes": "11 hours 28 mins",
      "poi_biking_minutes": "3 hours 24 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-e815-715b-807a-0bfba0685a5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-e815-715b-807a-0bfba0685a5d",
        "storage_key": "property/6767906449167589/019fc924-e815-715b-807a-0bfba0685a5d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_1579a8c9-4034-4e97-a5e0-af390a2aaa4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Saint Luke's Community Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "7246 W 75th St, Overland Park, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-e521-730b-bbfc-ad4922934afd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-e521-730b-bbfc-ad4922934afd",
        "storage_key": "property/6767906449167589/01a0101d-e521-730b-bbfc-ad4922934afd.webp",
        "width": 1280,
        "height": 938
      },
      "poi_business_url": "http://www.saintlukescommunityhospital.org/?utm_source=GMB&utm_campaign=local-listing#location",
      "poi_directions_map_url": "https://maps.google.com/?cid=7245941960554407119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-community-hospital",
      "poi_latitude": "38.9935432",
      "poi_longitude": "-94.6693198",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-222-8370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb67-7339-9551-ff8a96d45c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb67-7339-9551-ff8a96d45c58",
        "storage_key": "property/6767906449167589/019fc921-fb67-7339-9551-ff8a96d45c58.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJydg2E9btwIcRz2TxjdLBjmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5d39693f-4d27-438d-90a9-7b2c3d860de3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Aspiria",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6140 Sprint Pkwy STE 125, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019ff6c8-e55c-770a-93be-68cd9257d282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-e55c-770a-93be-68cd9257d282",
        "storage_key": "property/6767906449167589/019ff6c8-e55c-770a-93be-68cd9257d282.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://aspiriakc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6433786320914474865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aspiria",
      "poi_latitude": "38.9169728",
      "poi_longitude": "-94.6568885",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-285-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0ZxsczrwIcRceffOpJmSVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_011cd335-3818-4c50-af9b-98dc69819d56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-b888-7299-82f3-6e8c7ebb5985.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-b888-7299-82f3-6e8c7ebb5985",
        "storage_key": "property/6767906449167589/019fc924-b888-7299-82f3-6e8c7ebb5985.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_2edfee78-6266-4397-9cb8-8d4e3965db56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Johnson County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 S Cherry St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-e529-74ee-a0da-d87d119148fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-e529-74ee-a0da-d87d119148fb",
        "storage_key": "property/6767906449167589/01a0101d-e529-74ee-a0da-d87d119148fb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocogov.org/contact-us/all-locations/administration-building",
      "poi_directions_map_url": "https://maps.google.com/?cid=15575052816225759890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-administration-building",
      "poi_latitude": "38.8815028",
      "poi_longitude": "-94.8200342",
      "poi_miles_from_property": "13.8",
      "poi_walking_minutes": "5 hours 6 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 913-715-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019ff6c8-f7b8-74ba-8804-4b34b148a9a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6c8-f7b8-74ba-8804-4b34b148a9a7",
        "storage_key": "property/6767906449167589/019ff6c8-f7b8-74ba-8804-4b34b148a9a7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9_Fbvq9wIcRknIVJQS0Jdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_e5fb882e-876d-4114-9de1-69c1613a7644",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Cerner Corporation - World Headquarters Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2800 Rock Creek Pkwy, Kansas City, MO 64117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-e45b-7514-8e5e-8bd1d5dd7c37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-e45b-7514-8e5e-8bd1d5dd7c37",
        "storage_key": "property/6767906449167589/019fc924-e45b-7514-8e5e-8bd1d5dd7c37.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.cerner.com/?utm_source=google&utm_medium=organic&utm_campaign=organic-local-listings&utm_content=whq-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=1107266875381616454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cerner-corporation---world-headquarters-campus",
      "poi_latitude": "39.14986409999999",
      "poi_longitude": "-94.5459231",
      "poi_miles_from_property": "14.9",
      "poi_walking_minutes": "5 hours 34 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 816-221-1024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncA2l_X5wIcRRo-tSlvNXQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_e796d092-5ae2-4c9e-ad79-394b47fec1b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Hallmark Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 McGee St, Kansas City, MO 64108, USA",
      "poi_short_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_long_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101d-e5ee-763d-9f2b-fa2c39c2568d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-e5ee-763d-9f2b-fa2c39c2568d",
        "storage_key": "property/6767906449167589/01a0101d-e5ee-763d-9f2b-fa2c39c2568d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://corporate.hallmark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1199437302719612463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hallmark-corporate",
      "poi_latitude": "39.0811114",
      "poi_longitude": "-94.5800029",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 800-425-5627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzp5phbwwIcRL4b0Nt9BpRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1da85da4-8291-42ba-a1ab-df0d08c0c2cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc924-bb2d-72b8-8d15-8ec4cf9be6e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-bb2d-72b8-8d15-8ec4cf9be6e2",
        "storage_key": "property/6767906449167589/019fc924-bb2d-72b8-8d15-8ec4cf9be6e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "14.7",
      "poi_walking_minutes": "5 hours 25 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb68-71fd-83ce-36d0b5f61a25",
        "storage_key": "property/6767906449167589/019fc921-fb68-71fd-83ce-36d0b5f61a25.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_051ce3d1-df6b-4af4-89df-4c280ed10cbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "poi_name": "KU Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3901 Rainbow Blvd, Kansas City, KS 66160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-e4fc-722c-8c3f-9d0677451799.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc921-e4fc-722c-8c3f-9d0677451799",
        "storage_key": "property/6767906449167589/019fc921-e4fc-722c-8c3f-9d0677451799.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kumc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9948285583475587924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ku-medical-center",
      "poi_latitude": "39.0582747",
      "poi_longitude": "-94.6105991",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-588-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/019fc921-fb67-7339-9551-ff8a96d45c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-fb67-7339-9551-ff8a96d45c58",
        "storage_key": "property/6767906449167589/019fc921-fb67-7339-9551-ff8a96d45c58.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJdbsoKb3vwIcRVLszpwdpD4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    }
  ],
  "office_hours": [
    {
      "id": "ec_891edcdeecef3a603d485977",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e3f441d3fd12d56209409709",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_9079e184e2499250dee9ce7e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4e3e4ed4e4e91159e7b81f52",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_72dfdfc6a1008e4a0a2f167f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_f8be9b3aa6aa0cd64d2bb57e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "rating": "5",
      "name": "Bull Raven",
      "text": "I’ve been here for a couple years. Genuinely friendly neighbors and it’s peaceful. Any time I’ve had a maintenance request they are here fast. They never act like it’s an inconvenience and have typically done more than I asked in the first place. Staff is great. Levi came out today and got everything taken care of in a thorough and professional manner. Best apartment complex I’ve lived in.",
      "date": "2026-03-25",
      "title": "false"
    },
    {
      "id": "ec_df609091a043d5177e9e84ff",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "rating": "5",
      "name": "Tiffany Strain",
      "text": "Three formative years for my young family were spent here in this complex. It's been great! If you live on the third floor, I highly recommend installing blackout curtains for the vaulted ceiling windows. It has saved us hundreds in utility bills during the summer months!",
      "date": "2023-06-24",
      "title": "false"
    },
    {
      "id": "ec_e7da0dbddaf72f9cf5b3597a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "rating": "5",
      "name": "Jason T. Brown",
      "text": "Andy and Levi are the best maintenance men ever! They’re efficient, effective, and most importantly very good and amiable people.",
      "date": "2026-04-23",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_45ba4ab7c016a27f44648387",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-aab7-7717-bc4d-438d9855a4ee.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101c-aab7-7717-bc4d-438d9855a4ee",
        "storage_key": "property/6767906449167589/01a0101c-aab7-7717-bc4d-438d9855a4ee.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Astoria (A1)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=USZKTwPH95S"
    },
    {
      "id": "ec_587ea8e35243be42b586138b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-aacc-7032-a254-2665cad2d03f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101c-aacc-7032-a254-2665cad2d03f",
        "storage_key": "property/6767906449167589/01a0101c-aacc-7032-a254-2665cad2d03f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Louisville (A2)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=SpvwQtjkjnW"
    },
    {
      "id": "ec_39127490df088832246f4d7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-abbb-745b-b151-82c36d53540b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101c-abbb-745b-b151-82c36d53540b",
        "storage_key": "property/6767906449167589/01a0101c-abbb-745b-b151-82c36d53540b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Lexington (A3)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cE7QaRtn3u5"
    },
    {
      "id": "ec_ecaa1757ebbecfd60063b902",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-ac11-7446-86b9-b5d8b857c477.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101c-ac11-7446-86b9-b5d8b857c477",
        "storage_key": "property/6767906449167589/01a0101c-ac11-7446-86b9-b5d8b857c477.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Belmont (B1)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YSVm281oJhW"
    },
    {
      "id": "ec_85dd88a68494a7511023bc74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167589/01a0101c-ad34-7671-9d66-e8ad4a77b0a7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101c-ad34-7671-9d66-e8ad4a77b0a7",
        "storage_key": "property/6767906449167589/01a0101c-ad34-7671-9d66-e8ad4a77b0a7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Saratoga (B2)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=9Gaft7Wb5Lg"
    }
  ],
  "faqs": [
    {
      "id": "custom_fcf02e8f-f850-4065-b6c9-003521059675",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_5aef2eca-3999-4088-9e38-fec4322bcd6b",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d4633187-f6ee-496a-b0a5-a263e75a1823",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c947be48-df06-4913-bb24-1c3985282bbd",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_be311be8-4157-4453-b702-1a7a6da16ed8",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_828a9c54-baf2-4e37-8a79-c0b055aa4f13",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_394cf7f2-7832-4123-be67-7c04833abcbd",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_9899c8a6-cedd-4c7b-b246-3aa86dc53999",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_202d1f6e-cc01-4b1a-8f12-78b69b51fc07",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, electric and gas.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_9b043b69-09cd-4a86-81d3-4156101898b1",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_f704b566-50fe-4f50-95df-5571ae390d5c",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_4c735f25-171b-4f8b-be33-cf2df563e79f",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_30dc9533-d9ea-4f64-a531-9645ba9af973",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_731469e8-dd29-496f-8d1f-d5cdf70d28bd",
      "question": "Do you offer covered parking?",
      "answer": "We do not, however, we do offer assigned parking spaces for our residents and visitor parking areas.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_11801817-b1e6-4fbc-bf89-340e82af74a5",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_3248fa40-53f9-47d6-a5d2-c42938689195",
      "question": "Is there a space I can rent for get togethers?",
      "answer": "Yes! The Pavilion is available to rent. <a href=\"/contact-us\">Contact the office</a> for pricing and availability.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_d9385b4f-3d43-4416-b96a-7f87eb736714",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_56686e28-8cd3-4c16-b49c-2f6e52bbb676",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-2b01-72e9-be24-604d2370034a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Bremerton Park Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589"
    },
    {
      "lead_collector_id": "01a0c9ac-2bf7-7067-9411-82a1a4c40ada",
      "lead_source": "LANDING_PAGE",
      "name": "Bremerton Park Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "pool-apartments-prairie-village-ks",
      "search_query": "pool apartments Prairie Village KS",
      "category": "Amenity",
      "h1_title": "Pool Apartments in Prairie Village, KS",
      "h2_subtitle": "Discover stylish pool apartments in Prairie Village, KS. Enjoy Bremerton Park's lush landscapes and take advantage of spacious living and handy amenities.",
      "page_copy": "Looking for pool apartments in Prairie Village, KS? Bremerton Park Apartment Homes offers a serene, comfortable living environment with modern conveniences. Surrounded by beautifully landscaped courtyards, our community invites you to relax and enjoy spacious one- and two-bedroom layouts. Our apartments feature large closets, modern kitchens, and private outside entrances. \n\nWhile we do not have a pool on-site, our amenities such as balconies and vaulted ceilings set us apart. Located in Outlying Johnson County KS, Bremerton Park provides easy access to the area's best shopping and dining, offering a perfect blend of suburban tranquility and urban convenience. Discover your new home here and experience unparalleled peace in a vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Prairie Village, KS",
      "seo_description": "Explore pool apartments in Prairie Village, KS at Bremerton Park. Spacious, modern living in beautifully landscaped courtyards awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "apartments-large-closets-johnson-county",
      "search_query": "apartments with large closets Johnson County",
      "category": "Amenity",
      "h1_title": "Apartments with Large Closets Johnson County",
      "h2_subtitle": "Seek apartments with large closets in Johnson County? Bremerton Park offers spacious homes with ample storage and modern conveniences.",
      "page_copy": "If spacious storage is top of mind, Bremerton Park Apartment Homes in Johnson County is your ideal choice. Our one- and two-bedroom apartments include large closets, blending additional storage with contemporary living. Nestled in the scenic area of Outlying Johnson County KS, our homes provide the perfect setting to organize and enjoy spacious living.\n\nAlongside generous closet space, Bremerton Park boasts modern kitchens, private outdoor entrances, and the option of balconies. Residents appreciate the welcoming, landscaped courtyards and practical amenities like vaulted ceilings and washer/dryer hookups in select units. Discover a lifestyle of comfort and convenience in Prairie Village with us.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Large Closets Johnson County",
      "seo_description": "Find apartments with large closets in Johnson County. Bremerton Park offers roomy, modern living with practical features and spacious storage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "private-patio-apartment-homes-66204",
      "search_query": "private patio apartment homes 66204",
      "category": "Amenity",
      "h1_title": "Private Patio Apartment Homes 66204",
      "h2_subtitle": "Looking for private patio apartment homes in the 66204 area? Bremerton Park offers relaxing outdoor spaces and modern amenities for comfortable living.",
      "page_copy": "Experience the luxury of private patio apartment homes in the 66204 area at Bremerton Park. Nestled in Prairie Village, each of our one- and two-bedroom apartments offers a charming private outdoor space for relaxing or entertaining. Take advantage of the scenic, green courtyards that complement our calm, suburban setting.\n\nInside, you will find modern kitchens, large closets, and vaulted ceilings adding to an inviting, spacious feel. Bremerton Park is conveniently located in Outlying Johnson County KS, allowing easy access to local shopping and dining. Discover the perfect combination of indoor-outdoor living with our private patio spaces, offering tranquility and comfort right at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Private Patio Apartment Homes 66204",
      "seo_description": "Discover private patio apartment homes in 66204 at Bremerton Park. Enjoy outdoor spaces coupled with modern interiors and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "gated-community-prairie-village-ks",
      "search_query": "gated community Prairie Village KS",
      "category": "Amenity",
      "h1_title": "Gated Community in Prairie Village, KS",
      "h2_subtitle": "Seeking a gated community in Prairie Village, KS? Explore the welcoming environment and modern conveniences at Bremerton Park Apartment Homes.",
      "page_copy": "Discover the homey charm and modern amenities of Bremerton Park Apartment Homes, a unique option for those in search of a gated community in Prairie Village, KS. While Bremerton Park is not a gated community, it offers a serene, well-maintained setting with landscaped courtyards ideal for a safe and peaceful lifestyle. \n\nOur spacious one-and two-bedroom homes provide private outside entrances, ample storage space with large closets, and the convenience of modern kitchens. Situated in Outlying Johnson County KS, Bremerton Park boasts proximity to local dining and shopping, enhancing the suburban tranquility with urban accessibility. Here, experience a welcoming community atmosphere without the gated confines, offering both comfort and security.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community in Prairie Village, KS",
      "seo_description": "Explore a gated community lifestyle in Prairie Village, KS at Bremerton Park. Enjoy tranquil courtyards and spacious living just steps from city conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "apartment-with-dishwasher-outlying-johnson-county",
      "search_query": "apartment with dishwasher Outlying Johnson County KS",
      "category": "Amenity",
      "h1_title": "Apartment with Dishwasher in Outlying Johnson County",
      "h2_subtitle": "Searching for an apartment with a dishwasher in Outlying Johnson County KS? Bremerton Park provides contemporary kitchens that make everyday living a breeze.",
      "page_copy": "Enjoy the comforts of modern living at Bremerton Park Apartment Homes in Outlying Johnson County KS. Our spacious homes feature modern kitchens, providing essential conveniences like a dishwasher, designed to make daily routines seamless. This makes meal prep and clean-up simple, allowing you more time to relax and enjoy your beautifully appointed home.\n\nAt Bremerton Park, our one- and two-bedroom apartments also offer large closets, private outdoor entrances, and stunning vaulted ceilings for an open and airy feel. Located in the charming suburb of Prairie Village, our community presents a peaceful retreat just a short distance from the hustle and bustle of the city, enhancing the appeal of everyday convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Dishwasher Outlying Johnson County KS",
      "seo_description": "Discover apartments with dishwashers in Outlying Johnson County KS at Bremerton Park. Enjoy convenience with modern kitchens and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-prairie-village-ks",
      "search_query": "1 bedroom apartments Prairie Village KS",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Prairie Village, KS",
      "h2_subtitle": "Discover 1 bedroom apartments perfect for comfortable living in Prairie Village, KS. Bremerton Park offers spacious interiors and modern conveniences.",
      "page_copy": "Explore the inviting 1 bedroom apartments at Bremerton Park, located in the heart of Prairie Village, KS. Each apartment is designed with spacious interiors and includes modern kitchens and large closets, ensuring ample storage and functionality. Vaulted ceilings and private outside entrances enhance the appeal, offering an airy, open feel to every home.\n\nNestled in the tranquil setting of Outlying Johnson County, KS, Bremerton Park offers more than just a place to live. Our landscaped courtyards provide a serene escape, while proximity to local dining and shopping brings convenience right to your doorstep. Our 1-bedroom apartments combine comfort and style in a community-focused environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Prairie Village, KS",
      "seo_description": "Find spacious 1 bedroom apartments in Prairie Village, KS at Bremerton Park. Enjoy modern amenities and a tranquil setting in Outlying Johnson County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-johnson-county-kansas",
      "search_query": "2 bedroom apartments Johnson County Kansas",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Johnson County, KS",
      "h2_subtitle": "Seeking spacious 2 bedroom apartments in Johnson County Kansas? Bremerton Park offers the perfect blend of comfort and convenience.",
      "page_copy": "Locate your ideal home at Bremerton Park Apartment Homes, offering roomy 2 bedroom apartments right in the heart of Johnson County, KS. Our thoughtfully designed floor plans feature modern kitchens and expansive living spaces, perfect for both relaxation and entertaining. Each unit includes large closets and select units offer washer/dryer hookups for added convenience.\n\nThis charming community in Prairie Village provides more than just spacious interiors. Enjoy the tranquil surroundings with beautifully landscaped courtyards and private outdoor entrances that allow you to embrace indoor-outdoor living. Situated in Outlying Johnson County KS, Bremerton Park promises a harmonious blend of suburban calm and easy access to urban amenities, making everyday living a cherished experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Johnson County, KS",
      "seo_description": "Discover spacious 2 bedroom apartments in Johnson County, KS at Bremerton Park. Enjoy modern layouts in a serene Prairie Village setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "apartments-near-indian-hills-middle-school",
      "search_query": "apartments near indian hills middle school ks",
      "category": "School",
      "h1_title": "Apartments Near Indian Hills Middle School KS",
      "h2_subtitle": "Looking for apartments near Indian Hills Middle School in KS? Bremerton Park offers ideal living with modern amenities and a convenient location.",
      "page_copy": "Discover your perfect home at Bremerton Park Apartment Homes, conveniently located near Indian Hills Middle School in KS. Our community provides spacious one- and two-bedroom units, designed to cater to modern living with features like updated kitchens and vast storage options, ensuring a comfortable and functional lifestyle.\n\nSituated in the serene neighborhood of Prairie Village in Outlying Johnson County, Bremerton Park allows easy access to quality education while enjoying suburban tranquility. Our peaceful community includes beautifully landscaped courtyards and private balconies, supporting a balanced lifestyle with the convenience of nearby educational and recreational facilities. Choose Bremerton Park for a well-rounded living experience in proximity to Indian Hills Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Indian Hills Middle School KS",
      "seo_description": "Find apartments near Indian Hills Middle School KS at Bremerton Park. Enjoy spacious layouts and modern amenities, ideal for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "bremerton-park-apartments-by-prairie-elementary",
      "search_query": "bremerton park apartments by prairie elementary",
      "category": "School",
      "h1_title": "Bremerton Park Apartments near Prairie Elementary",
      "h2_subtitle": "Searching for Bremerton Park Apartments by Prairie Elementary? Enjoy convenient living close to schools and essential amenities.",
      "page_copy": "Bremerton Park Apartments offers a convenient location just a stone's throw away from Prairie Elementary. Situated in Prairie Village, our community provides spacious one- and two-bedroom homes featuring modern kitchens and generous storage. \n\nLiving at Bremerton Park means benefiting from a peaceful environment close to local schools and amenities. Our landscaped courtyards, private outside entrances, and welcoming atmosphere make it an excellent choice for those who value proximity to Prairie Elementary. Plus, being in the serene area of Outlying Johnson County KS, residents enjoy a quiet suburban feel with easy access to local necessities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bremerton Park Apts by Prairie Elementary",
      "seo_description": "Live close to Prairie Elementary in Bremerton Park Apartments. Enjoy modern amenities in Prairie Village's serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "prairie-village-apartments-near-belinder-elementary",
      "search_query": "prairie village apartments near belinder elementary",
      "category": "School",
      "h1_title": "Prairie Village Apartments Near Belinder Elementary",
      "h2_subtitle": "Looking for Prairie Village apartments near Belinder Elementary? Bremerton Park provides a welcoming community with spacious layouts and everyday convenience.",
      "page_copy": "Settle into a comfortable home at Bremerton Park Apartment Homes, perfectly situated near Belinder Elementary in Prairie Village. Our spacious one- and two-bedroom apartment homes boast features like updated kitchens and ample storage options. Bremerton Park offers a harmonious living experience, combining convenience with comfort. \n\nNestled in Outlying Johnson County, KS, Bremerton Park offers proximity to schools like Belinder Elementary and serene community spaces. With private balconies, landscaped courtyards, and private entrances, residents enjoy a peaceful atmosphere close to essential local destinations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prairie Village Apts Near Belinder Elementary",
      "seo_description": "Find your next home at Bremerton Park, near Belinder Elementary in Prairie Village. Enjoy spacious living and convenient proximity to schools.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "apartments-by-shawnee-mission-east-high-school",
      "search_query": "apartments by shawnee mission east high school",
      "category": "School",
      "h1_title": "Apartments by Shawnee Mission East High School",
      "h2_subtitle": "Looking for apartments near Shawnee Mission East High School? Discover the comfort and convenience of Bremerton Park in Prairie Village.",
      "page_copy": "Bremerton Park Apartment Homes are ideally located near Shawnee Mission East High School. Our spacious one- and two-bedroom apartments offer modern amenities such as updated kitchens and large closets, designed to accommodate your lifestyle needs.\n\nNestled in the charming community of Prairie Village within Outlying Johnson County, KS, Bremerton Park provides a welcoming environment for residents. With private outside entrances, lush green courtyards, and easy access to local high schools, our apartments offer the convenience and community connection you desire. Discover the ease and comfort of living at Bremerton Park, minutes away from Shawnee Mission East High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Shawnee Mission East High School",
      "seo_description": "Find your home at Bremerton Park, close to Shawnee Mission East High School. Enjoy modern amenities and a welcoming environment in Prairie Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "apartments-close-to-briarwood-elementary-school",
      "search_query": "apartments close to briarwood elementary school",
      "category": "School",
      "h1_title": "Apartments Near Briarwood Elementary School",
      "h2_subtitle": "Searching for apartments close to Briarwood Elementary School? Discover the amenities and convenience of Bremerton Park Apartment Homes.",
      "page_copy": "Bremerton Park Apartment Homes offer a convenient setting near Briarwood Elementary School. Our spacious one- and two-bedroom apartments provide a comfortable living space with features such as modern kitchens, large closets, and practical amenities. \n\nLocated in the tranquil area of Prairie Village, within Outlying Johnson County KS, Bremerton Park offers a peaceful, welcoming community atmosphere. Our apartment homes feature private entrances and scenic courtyards, creating a serene environment. With conveniences like online rental payments and a resident app, Bremerton Park combines modern living with easy access to Briarwood Elementary School, making daily life smooth and enjoyable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Briarwood Elementary School",
      "seo_description": "Find comfortable living at Bremerton Park, close to Briarwood Elementary School. Experience modern amenities and a welcoming community in Prairie Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "johnson-county-apts-near-community-college",
      "search_query": "johnson county apts near community college",
      "category": "School",
      "h1_title": "Johnson County Apartments Near Community College",
      "h2_subtitle": "Looking for Johnson County apartments near a community college? Explore Bremerton Park Apartment Homes in Prairie Village.",
      "page_copy": "Bremerton Park Apartment Homes in Prairie Village offer an ideal location for students and staff of nearby community colleges. Our one- and two-bedroom apartments are designed with modern conveniences, such as updated kitchens and large closets, making them a perfect fit for those seeking comfort and practicality.\n\nSituated in Outlying Johnson County KS, Bremerton Park provides easy access to area colleges while offering a serene living environment. Enjoy the benefits of private entrances and landscaped courtyards, creating a peaceful home base for your studies. With amenities like online rental payments and a resident app, managing your apartment life is simple. Choose Bremerton Park for proximity to community colleges and enjoy modern living in a welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Johnson County Apartments Near Community College",
      "seo_description": "Discover Bremerton Park Apartments, located near community colleges in Johnson County. Enjoy modern amenities and a serene environment in Prairie Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "apartments-near-adventhealth-shawnee-mission-prairie-village",
      "search_query": "apartments near AdventHealth Shawnee Mission Prairie Village",
      "category": "Hospital",
      "h1_title": "Apartments Near AdventHealth Shawnee Mission",
      "h2_subtitle": "Seeking apartments near AdventHealth Shawnee Mission? Bremerton Park offers modern living in Prairie Village, perfect for healthcare professionals.",
      "page_copy": "Bremerton Park Apartment Homes provide the perfect home for those working at or visiting AdventHealth Shawnee Mission. Located in Prairie Village, our spacious one- and two-bedroom apartments are ideal for those who need a convenient place close to the hospital while enjoying the relaxing atmosphere of suburban life.\n\nOur community features modern kitchens, large closets, and beautifully landscaped courtyards, offering a blend of comfort and style. With amenities like private entrances and online rental management, life at Bremerton Park is straightforward and enjoyable. Surrounded by the beauty of Outlying Johnson County KS, Bremerton Park Apartment Homes provide a practical living solution near AdventHealth Shawnee Mission.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near AdventHealth Shawnee Mission Prairie Village",
      "seo_description": "Find Bremerton Park Apartments near AdventHealth Shawnee Mission in Prairie Village. Enjoy modern amenities and tranquil living in Johnson County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "apartments-close-to-saint-lukes-community-hospital-johnson-county",
      "search_query": "apartments close to Saint Luke's Community Hospital Johnson County",
      "category": "Hospital",
      "h1_title": "Apartments Near Saint Luke's Community Hospital",
      "h2_subtitle": "Looking for apartments close to Saint Luke's Community Hospital in Johnson County? Bremerton Park offers the perfect location.",
      "page_copy": "For those working at or needing regular visits to Saint Luke's Community Hospital in Johnson County, Bremerton Park Apartment Homes offer a convenient and comfortable living option. Situated in the welcoming community of Prairie Village, our one- and two-bedroom apartments come with modern kitchens and large closets, perfect for a relaxed lifestyle.\n\nLocated in Outlying Johnson County KS, Bremerton Park provides easy access to the hospital while ensuring a serene environment for residents. Enjoy features like private entrances, a resident app, and beautifully landscaped courtyards. For those seeking practical and stylish living near Saint Luke's Community Hospital, Bremerton Park Apartment Homes are an ideal choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Saint Luke's Community Hospital Johnson Co",
      "seo_description": "Discover Bremerton Park Apartments close to Saint Luke's Community Hospital in Johnson County. Enjoy modern living with convenient hospital access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "apartments-near-overland-park-arboretum-botanical-gardens",
      "search_query": "apartments near overland park arboretum botanical gardens prairie village",
      "category": "Park",
      "h1_title": "Apts Near Overland Park Arboretum & Gardens",
      "h2_subtitle": "Looking for apartments near Overland Park Arboretum & Botanical Gardens? Bremerton Park offers a serene sanctuary in Prairie Village.",
      "page_copy": "Nestled in Prairie Village, Bremerton Park Apartment Homes are perfectly located for nature enthusiasts who want easy access to the Overland Park Arboretum & Botanical Gardens. Our spacious one- and two-bedroom apartments are designed with modern touches like updated kitchens and large closets, ideal for those seeking a harmonious blend of convenience and comfort.\n\nLocated in the tranquil area of Outlying Johnson County KS, Bremerton Park offers the beauty of landscaped courtyards and private entrances. Residents enjoy practical amenities such as online rental payments and a resident app. For those who love the tranquility of nature, yet want easy urban access, Bremerton Park Apartment Homes make an excellent choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Overland Park Arboretum & Gardens",
      "seo_description": "Live near Overland Park Arboretum & Gardens at Bremerton Park in Prairie Village. Enjoy modern apartments and serene surroundings in Johnson County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "bremerton-park-apartments-near-meadowbrook-park-clubhouse",
      "search_query": "bremerton park apartments close to meadowbrook park clubhouse ks",
      "category": "Park",
      "h1_title": "Bremerton Park Apts Near Meadowbrook Clubhouse",
      "h2_subtitle": "Discover Bremerton Park Apartments, close to Meadowbrook Park Clubhouse in KS. Enjoy easy access to this popular local attraction.",
      "page_copy": "Bremerton Park Apartment Homes offer an ideal location for those who love being near the vibrant activities of Meadowbrook Park Clubhouse in KS. Situated in Prairie Village, our spacious one- and two-bedroom homes combine modern amenities with cozy charm, making it easy to enjoy the best of both worlds.\n\nOur complex provides features like vaulted ceilings, private entrances, and lush courtyards, bringing comfort and convenience to life in Outlying Johnson County KS. Whether you want to stroll through expansive green spaces or enjoy the amenities such as the resident app and online payment options, Bremerton Park is the perfect fit for a lifestyle rich in leisure and practicality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bremerton Park Apts by Meadowbrook Park Clubhouse",
      "seo_description": "Experience the charm of Bremerton Park Apartments, close to Meadowbrook Park Clubhouse KS. Enjoy modern living and nearby park amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "prairie-village-apartments-near-harmon-park",
      "search_query": "prairie village apartments near harmon park",
      "category": "Park",
      "h1_title": "Apartments Near Harmon Park in Prairie Village",
      "h2_subtitle": "Explore Prairie Village apartments near Harmon Park. Bremerton Park offers the perfect blend of comfort and location.",
      "page_copy": "Discover Bremerton Park Apartment Homes, ideally located near Harmon Park in the charming community of Prairie Village. Our spacious one- and two-bedroom apartments offer the ideal retreat filled with modern conveniences such as large closets and updated kitchens, perfect for anyone looking to enjoy this vibrant area.\n\nNestled in Outlying Johnson County KS, Bremerton Park provides an inviting atmosphere with beautifully landscaped courtyards and private entrances. With amenities like a resident app and online payment options, Bremerton Park ensures a seamless living experience. Enjoy easy access to Harmon Park and local community events, all while living in a comfortable, modern home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prairie Village Apts Close to Harmon Park",
      "seo_description": "Live comfortably at Bremerton Park Apartments, close to Harmon Park in Prairie Village. Modern living with easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "apartments-near-bennett-park-johnson-county",
      "search_query": "apartments near bennett park johnson county",
      "category": "Park",
      "h1_title": "Apts Near Bennett Park, Johnson County",
      "h2_subtitle": "Find apartments near Bennett Park in Johnson County at Bremerton Park. Enjoy spacious living with modern amenities.",
      "page_copy": "Positioned perfectly in Prairie Village, Bremerton Park Apartment Homes provide a comfortable home near Bennett Park in Johnson County. Our thoughtfully designed one- and two-bedroom apartments offer a relaxing haven that comes with modern kitchens, ample storage, and private entries, ideal for anyone wanting easy access to local amenities.\n\nIn the beautiful setting of Outlying Johnson County KS, our community features stunning landscaped courtyards and practical amenities like an online resident portal and payment system. Bremerton Park's proximity to Bennett Park means residents can enjoy outdoor activities and a peaceful neighborhood, all while benefiting from a cozy, modern living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Bennett Park, Johnson County",
      "seo_description": "Enjoy modern living near Bennett Park, Johnson County at Bremerton Park. Spacious, convenient living in a serene, natural setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "bremerton-park-rentals-near-brenizer-park-ks",
      "search_query": "bremerton park rentals near brenizer park ks",
      "category": "Park",
      "h1_title": "Bremerton Park Rentals by Brenizer Park KS",
      "h2_subtitle": "Explore rentals at Bremerton Park near Brenizer Park KS. Enjoy a perfect blend of comfort and accessibility.",
      "page_copy": "Bremerton Park Apartment Homes offer rentals perfectly situated close to Brenizer Park in KS, providing residents with both comfort and convenience. Our spacious one- and two-bedroom homes feature modern amenities such as large closets and private entrances, making them ideal for anyone looking to enjoy the proximity to local parks and activities.\n\nLocated in the serene environment of Prairie Village within Outlying Johnson County KS, our community is designed to enhance modern living with features like a resident app and beautifully landscaped courtyards. Whether you're relaxing at home or exploring Brenizer Park, Bremerton Park Rentals offer an unbeatable location and living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bremerton Park Rentals Near Brenizer Park KS",
      "seo_description": "Discover Bremerton Park Rentals near Brenizer Park KS. Experience modern living and convenience in a park-rich environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "prairie-village-ks-apartments-by-franklin-park",
      "search_query": "prairie village ks apartments by franklin park",
      "category": "Park",
      "h1_title": "Apartments by Franklin Park, Prairie Village KS",
      "h2_subtitle": "Discover Prairie Village KS apartments by Franklin Park. Bremerton Park offers modern homes in a prime location.",
      "page_copy": "Bremerton Park Apartment Homes are ideally located near Franklin Park in Prairie Village KS, offering residents both modern living and easy access to nature. Our one- and two-bedroom apartments boast roomy interiors, updated kitchens, and extensive closet space, designed to meet the needs of those who desire comfort and convenience.\n\nSet in the tranquil locale of Outlying Johnson County KS, Bremerton Park provides a peaceful atmosphere enhanced by landscaped courtyards and privacy-focused features like individual entrances. With our resident app and online payment options, daily life becomes effortless. Experience the best of both worlds with easy access to Franklin Park's outdoor amenities and the comforts of home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prairie Village KS Apts by Franklin Park",
      "seo_description": "Live at Bremerton Park, close to Franklin Park, Prairie Village KS. Enjoy spacious, modern apartments in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "apartments-close-to-porter-park-prairie-village-ks",
      "search_query": "apartments close to porter park prairie village kansas",
      "category": "Park",
      "h1_title": "Apartments Near Porter Park, Prairie Village KS",
      "h2_subtitle": "Find apartments close to Porter Park in Prairie Village Kansas. Bremerton Park offers ideal living spaces.",
      "page_copy": "Bremerton Park Apartment Homes, located close to Porter Park in Prairie Village Kansas, provide an excellent living option for those seeking a blend of natural beauty and modern amenities. Our spacious one- and two-bedroom apartments are equipped with updated kitchens and generous storage, perfect for residents who appreciate both style and functionality.\n\nNestled within the peaceful surroundings of Outlying Johnson County KS, Bremerton Park boasts amenities like private entrances and beautifully landscaped courtyards. With convenient features such as an online resident portal and payment system, living here makes daily routines effortless. Enjoy the proximity to Porter Park while savoring the comforts of modern apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Porter Park, Prairie Village KS",
      "seo_description": "Discover Bremerton Park, offering apartments near Porter Park, Prairie Village KS. Experience spacious living in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "bremerton-park-homes-near-shaffer-park-66204",
      "search_query": "bremerton park homes near shaffer park 66204",
      "category": "Park",
      "h1_title": "Bremerton Park Homes by Shaffer Park 66204",
      "h2_subtitle": "Explore Bremerton Park homes located near Shaffer Park in the 66204 area. Enjoy spacious living and lush surroundings.",
      "page_copy": "Bremerton Park Apartment Homes, situated near Shaffer Park in the 66204 area, offers a perfect retreat with its spacious one- and two-bedroom units designed for contemporary living. Each home features modern kitchens and ample closet space, ensuring comfort and practicality for residents.\n\nLocated in the charming Prairie Village and Outlying Johnson County KS, our community provides tranquility and convenience. Residents can enjoy beautifully landscaped courtyards, private entrances, and online amenities such as a resident app for easy living. Being close to Shaffer Park allows for a seamless blend of outdoor recreation and comfortable home life at Bremerton Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bremerton Park Homes Near Shaffer Park 66204",
      "seo_description": "Live at Bremerton Park, near Shaffer Park in 66204. Spacious homes with modern amenities in a serene Prairie Village setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167589",
      "source": "custom",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near KC International Airport",
      "h2_subtitle": "Find stylish apartments conveniently located near Kansas City International Airport. Bremerton Park offers modern amenities for a stress-free lifestyle.",
      "page_copy": "Although Bremerton Park Apartment Homes are located in Prairie Village KS, they offer a convenient living option for those who need access to Kansas City International Airport. Our spacious one- and two-bedroom homes feature modern kitchens and ample closet space, ensuring that residents enjoy both comfort and convenience.\n\nSituated in the charming Outlying Johnson County KS, Bremerton Park provides a peaceful retreat with fantastic amenities such as landscaped courtyards and private entrances. The availability of online rental payments and a resident app simplifies daily life. Residents can enjoy a tranquil lifestyle, yet remain connected with quick access routes to the airport, making it perfect for frequent travelers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019ff6c5-f123-73c9-8352-e8fe59ff6624",
        "storage_key": "property/6767906449167589/019ff6c5-f123-73c9-8352-e8fe59ff6624.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Kansas City International Airport",
      "seo_description": "Discover Bremerton Park apartments near Kansas City International Airport. Enjoy modern amenities in a peaceful setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701864453"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-52Q3G3TK"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 8"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/f27800d1-73c0-4863-816e-14c95dec2149/app.js?nocache=1&gaTracking=G-2KN67WNZZX&buttonbgcolor=c63527&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-543-4475"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjlpekxBWDRaV2VsNzhicEFOcHkwdUE9PSIsInZhbHVlIjoiOE1FUTVLYXZINnlmYVRHdk50cmFVZz09IiwibWFjIjoiNDRlMGZmNDk3OGJmZGZhZDk5NDgxYjNhMTkwOTc0M2ZhNTY5YjM5MzhjZWMwYjUwOGIzMDgyYWYwMWNkZjI4OCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701864453",
  "custom_google_gtm_id": "GTM-52Q3G3TK",
  "custom_rollout_phase": "Batch 8",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/f27800d1-73c0-4863-816e-14c95dec2149/app.js?nocache=1&gaTracking=G-2KN67WNZZX&buttonbgcolor=c63527&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-543-4475",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjlpekxBWDRaV2VsNzhicEFOcHkwdUE9PSIsInZhbHVlIjoiOE1FUTVLYXZINnlmYVRHdk50cmFVZz09IiwibWFjIjoiNDRlMGZmNDk3OGJmZGZhZDk5NDgxYjNhMTkwOTc0M2ZhNTY5YjM5MzhjZWMwYjUwOGIzMDgyYWYwMWNkZjI4OCJ9",
  "custom_audioeye_site_id": "0427e9e1-e244-417f-bd56-11c6e72ebc03",
  "custom_audioeye_site_hash": "09912af09ce3817811d1d2d667af3301"
};

export const generatedAt = '2026-11-03T22:59:22.568Z';
